<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Patient Portal</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="dashboard">Home</a>
                </li>
                <li class="breadcrumb-item active">Patient Portal</li>
              </ol>
            </div>
          </div>
        </div>

        <!-- <div class="row justify-content-end"> -->

        <PatientsSearchComponent
          @apply-search-click="applySearchClick()"
          :called_by="'PatientPortal'"
        ></PatientsSearchComponent>
        <!-- </div> -->
        <!-- <div class="row justify-content-end">
          <div class="col-12">
            <form class="floating-labels">
              <div class="row">
                <div class="col-2">
                  <div class="form-group">
                    <span class="p-float-label">
                      <InputText
                        type="text"
                        id=""
                        placeholder=""
                        class="float-class1"
                        style="width: 100%"
                        v-model="mainSearch.searchExternalId"
                      />
                      <label style="margin-top:-4.5px; !important" id="font1"
                        >External ID</label
                      >
                    </span>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-group">
                    <span class="p-float-label">
                      <InputText
                        type="text"
                        class="float-class1"
                        id=""
                        placeholder=""
                        maxlength="50"
                        v-model="mainSearch.searchFirstName"
                        style="width: 100%"
                      />
                      <label style="margin-top:-4.5px; !important" id="font1"
                        >Search By First Name</label
                      >
                    </span>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-group">
                    <span class="p-float-label">
                      <InputText
                        type="text"
                        class="float-class1"
                        id=""
                        placeholder=""
                        maxlength="50"
                        v-model="mainSearch.searchLastName"
                        style="width: 100%"
                      />
                      <label style="margin-top:-4.5px; !important" id="font1"
                        >Search By Last Name</label
                      >
                    </span>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-group">
                    <span class="p-float-label">
                      <InputText
                        v-mask="'###-###-####'"
                        type="tel"
                        class="float-class1"
                        id=""
                        placeholder=""
                        v-model="mainSearch.searchPhone"
                        style="width: 100%"
                      />
                      <label style="margin-top:-4.5px; !important" id="font1"
                        >Search By Phone</label
                      >
                    </span>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-group">
                    <label style="margin-top: -22px; font-weight: bold"
                      >Date</label
                    >
                    <InputText
                      type="date"
                      class="float-class1"
                      id=""
                      v-model="mainSearch.searchDate"
                      style="width: 100%"
                    /><span class="bar"></span>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div> -->

        <div hidden class="row justify-content-end">
          <div class="col-sm-4">
            <div class="text-right">
              <button
                class="btn btn-success waves-effect mt-2 mb-2"
                type="button"
                data-toggle="modal"
                data-target="#uploadModal"
              >
                Upload
              </button>
            </div>
          </div>
        </div>

        <div class="card p-3">
          <div class="table-responsive">
            <div
              class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
            >
              <div class="dataTables_length">
                <span style="margin-right: 10px"
                  ><label for="">Show </label>
                </span>
                <select
                  v-model="pageSize"
                  class="form-control form-control-sm"
                  aria-label="Default select example"
                  @change="pageChange(1)"
                >
                  <option selected>50</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                  <option value="2000">2000</option>
                </select>

                <span style="margin-left: 10px">
                  <label for=""> Entries </label></span
                >
              </div>
            </div>
            <table
              class="
                table
                display
                table-bordered
                text-center
                table-striped
                no-wrap
              "
              id="home_2"
            >
              <thead class="thead-dark">
                <tr>
                  <th style="text-align: start">
                    View Patients<span>
                      <!-- <button class="asc-desc-btn" @click="orderBy(1)">
                        &uarr; &darr;
                      </button> -->
                    </span>
                  </th>
                  <th style="text-align: start">
                    First Name<span>
                      <button class="asc-desc-btn" @click="orderBy(1)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Last Name<span>
                      <button class="asc-desc-btn" @click="orderBy(2)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    DOB<span>
                      <button class="asc-desc-btn" @click="orderBy(3)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    PTID<span>
                      <button class="asc-desc-btn" @click="orderBy(4)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    External ID<span>
                      <button class="asc-desc-btn" @click="orderBy(5)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    SSN<span>
                      <button class="asc-desc-btn" @click="orderBy(6)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Gender<span>
                      <button class="asc-desc-btn" @click="orderBy(7)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Email<span>
                      <button class="asc-desc-btn" @click="orderBy(8)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Phone<span>
                      <button class="asc-desc-btn" @click="orderBy(9)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                </tr>
              </thead>

              <tbody>
                  <tr v-if="allFilterPatients.length == 0">
                      <td align="center" colspan="100">
                        <strong> No data available</strong>
                      </td>
                 </tr>
                <tr v-for="(pat, ndx01) in allFilterPatients" :key="ndx01">
                  <td>
                    <div class="btn-group">
                      <button
                        type="button"
                        class="btn btn-success"
                        :class="calcMainButtonClass(pat)"
                        @click="showProfilPopUpBro(pat, '')"
                      >
                        View Profile
                        <!-- {{ pat.firstName + " " + pat.lastName }}<br /><strong>{{
                          pat.doBstr
                        }}</strong> -->
                      </button>
                      <button
                        type="button"
                        :class="calcMainButtonClass(pat)"
                        @click="dropDownButtonClick(pat)"
                        class="
                          btn btn-success
                          dropdown-toggle dropdown-toggle-split
                        "
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span class="sr-only">Toggle Dropdown</span>
                      </button>
                      <div
                        v-if="delButton == 1"
                        class="dropdown-menu animated flipInY"
                      >
                        <a
                          class="dropdown-item"
                          href="javascript:void(0)"
                          @click="mergeModalClick(pat)"
                          ><i
                            v-if="pat.patientId <= 0"
                            class="fas fa-exclamation text-danger"
                          ></i
                          >&nbsp; Merge Patients</a
                        >
                        <a
                          class="dropdown-item"
                          href="javascript:void(0)"
                          data-toggle="modal"
                          id="delete_request"
                          @click="requestDeleteClick(pat)"
                          >Delete</a
                        >
                      </div>
                      <div v-else class="dropdown-menu animated flipInY">
                        <a
                          class="dropdown-item"
                          href="javascript:void(0)"
                          @click="mergeModalClick(pat)"
                          ><i
                            v-if="pat.patientId <= 0"
                            class="fas fa-exclamation text-danger"
                          ></i
                          >&nbsp; Merge Patients</a
                        >
                      </div>
                    </div>
                  </td>
                  <td v-if="pat.patientId > 0">
                    <strong>
                      <strong> {{ pat.firstName }}</strong>
                    </strong>
                  </td>
                  <td v-if="pat.patientId > 0">
                    <strong>
                      <strong>
                        {{ pat.lastName }}
                      </strong>
                    </strong>
                  </td>
                  <td v-if="pat.patientId > 0">
                    <strong>
                      <strong> {{ pat.dob }}</strong>
                    </strong>
                  </td>
                  <td v-if="pat.patientId > 0">
                    {{ pat.ptid }}
                  </td>
                  <td v-else>--</td>
                  <td>{{ pat.externalId }}</td>
                  <td>{{ pat.ssn }}</td>
                  <td>{{ pat.gender }}</td>
                  <td>{{ pat.email }}</td>
                  <td>{{ pat.phone }}</td>
                </tr>
              </tbody>
            </table>
          </div>
              <!--show pagination--> 
          <nav aria-label="Page navigation" style="float: right">
            <span
              style="padding-left: 40px"
              v-if="totalRows < pageSize * pageNumber"
              >showing {{ totalRows }} of {{ totalRows }} records</span
            >
            <span style="padding-left: 40px" v-else
              >showing {{ pageSize * pageNumber }} of
              {{ totalRows }} records</span
            >
            <ul class="pagination" style="float: right">
              <li class="page-item colorActive">
                <span v-if="pageNumber == 1">
                  <button
                    disabled
                    class="page-link disabledColor"
                    @click="pageChange('Previous')"
                  >
                    Previous
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange('Previous')">
                    Previous
                  </button>
                </span>
              </li>
                  <!--show pagination--> 
              <li v-if="showPagesMin > 1">
                 <button class="page-link" @click="pageChange(1)">
                    1
                  </button>
             </li>
              <li v-if=" showPagesMin>1 ">
                 <button
                    disabled
                    class="page-link disabledColor"
                  >
                    ...
                  </button>
              </li>
                 <!--show pagination--> 
              <li
                v-for="pageNum in totalPages"
                :key="pageNum"
                class="page-item colorActive"
              >
                <span v-if="pageNum >= showPagesMin && pageNum <= showPagesMax"> 
                <span v-if="pageNumber == pageNum"
                  ><button
                    class="page-link activeColor"
                    disabled
                    @click="pageChange(pageNum)"
                  >
                    {{ pageNum }}
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange(pageNum)">
                    {{ pageNum }}
                  </button></span
                >
                </span>
              </li>

              <!--show pagination-->          
              <li v-if="totalPages > 10 && (totalPages-4) >= pageNumber">
                 <button
                    disabled
                    class="page-link disabledColor"
                  >
                    ...
                  </button>
              </li>
             <li v-if="totalPages > 10 &&  (totalPages-4) >= pageNumber">
                 <button class="page-link" @click="pageChange(totalPages)">
                    {{ totalPages }}
                  </button>
             </li>
               <!--show pagination-->   
              <li class="page-item colorActive"> 
                <span v-if="pageNumber == totalPages">
                  <button
                    disabled
                    class="page-link disabledColor"
                    @click="pageChange('Next')"
                  >
                    Next
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange('Next')">
                    Next
                  </button>
            
                </span>
              </li>
            </ul>
          </nav>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
    <!--  -->
    <!--  ~~MODALS -->
    <!-- New Patients Modal newptModal-->
    <div
        class="modal fade"
        id="newptModalCom"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
        style="display: none"
      >
      <PatientComponent :patientId="patientId" :visitId="visitId" :FetchTableData="loadInit" ref="patientComponent" :AppModelId='2' v-if="showProfilePopupVar==true"></PatientComponent>
      </div>
    <!-- New Patients Modal -->

 <!-- Payment Authorize Credit -->
    <div
      id="debit"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Payment Via Authorize</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <h4 class="font-weight-bold h4-responsive">
              Payment Verfication will be Done
            </h4>
            <form class="floating-labels m-t-40">
              <div
                class="form-group m-b-40"
                :class="[
                  aSinglePaymentReceived.holderName != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                  <InputText
                    type="text"
                    class="form-control float-class"
                    id=""
                    maxlength="30"
                    v-model="aSinglePaymentReceived.holderName"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Card Holder Name<span style="color: red"> *</span></label
                  >
                </span>
              </div>
              <div
                class="form-group m-b-40"
                :class="[
                  aSinglePaymentReceived.tdNumber != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                  <InputText
                    v-mask="'####-####-####-####'"
                    type="tel"
                    class="form-control float-class"
                    id=""
                    v-model="aSinglePaymentReceived.tdNumber"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Card Number<span style="color: red"> *</span></label
                  >
                </span>
              </div>
              <div
                class="form-group m-b-40"
                :class="[
                  aSinglePaymentReceived.cardCVC != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                  <InputText
                    v-mask="'######'"
                    type="tel"
                    class="form-control float-class"
                    id=""
                    v-model="aSinglePaymentReceived.cardCVC"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Card CVC<span style="color: red"> *</span></label
                  >
                </span>
              </div>
              <div
                class="form-group m-b-40"
                :class="[aSinglePaymentReceived.zip != null ? '' : 'focused']"
              >
                <span class="p-float-label">
                  <InputText
                    type="text"
                    class="form-control float-class"
                    id=""
                    maxlength="8"
                    v-model="aSinglePaymentReceived.zip"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Zip<span style="color: red"> *</span></label
                  >
                </span>
              </div>
              <div
                class="form-group m-b-40"
                :class="[aSinglePaymentReceived.amount != null ? '' : 'focused']"
              >
                <span class="p-float-label">
                  <InputText
                    type="number"
                    class="form-control float-class"
                    min="0"
                    id=""
                    disabled
                    @keypress="isNumber($event)"
                    v-model="aSinglePaymentReceived.amount"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Amount<span style="color: red"> *</span></label
                  >
                </span>
              </div>
              <div
                class="form-group"
                :class="[
                  aSinglePaymentReceived.comment != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                  <InputText
                    class="form-control float-class"
                    id=""
                    maxlength="255"
                    v-model="aSinglePaymentReceived.comment"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Comment<span style="color: red"> *</span>:</label
                  >
                </span>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              id="creditCardPayment"
              @click="paymentReceivedClick('credit-card')"
            >
              Process
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Payment Authorize Credit  -->
    
   <div
      id="cash"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Cash On The Spot</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div
                class="form-group m-b-40"
                v-bind:class="[
                  aSinglePaymentReceived.amount != null ? 'focused' : '',
                ]"
              >
                <input
                  type="number"
                  class="form-control"
                  id=""
                  min="0"
                  disabled
                  @keypress="isNumber($event)"
                  v-model="aSinglePaymentReceived.amount"
                /><span class="bar"></span>
                <label for=""
                  >Amount(In $)<span style="color: red"> *</span></label
                >
              </div>
              <div
                class="form-group"
                :class="[
                  aSinglePaymentReceived.comment != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                  <InputText
                    class="form-control float-class"
                    id=""
                    maxlength="255"
                    v-model="aSinglePaymentReceived.comment"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Comment<span style="color: red"> *</span>:</label
                  >
                </span>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              id="cashPayment"
              @click="paymentReceivedClick('cash')"
            >
              Collect
            </button>
          </div>
        </div>
      </div>
    </div>

     <!-- Payment Authorize cheque -->
    <div
      id="cheque"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Payment Via Cheque</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div
                class="form-group m-b-40"
                v-bind:class="[
                  aSinglePaymentReceived.tdNumber != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                  <InputText
                    v-mask="'####-####-####-####'"
                    type="tel"
                    class="form-control float-class"
                    id=""
                    v-model="aSinglePaymentReceived.tdNumber"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Cheque Number<span style="color: red"> *</span></label
                  >
                </span>
              </div>
              <div
                class="form-group m-b-40"
                v-bind:class="[
                  aSinglePaymentReceived.amount != null ? 'focused' : '',
                ]"
              >
                <input
                  type="number"
                  class="form-control"
                  id=""
                  min="0"
                  disabled
                  @keypress="isNumber($event)"
                  v-model="aSinglePaymentReceived.amount"
                /><span class="bar"></span>
                <label for=""
                  >Amount(In $)<span style="color: red"> *</span></label
                >
              </div>
              <div
                class="form-group m-b-40"
                v-bind:class="[
                  aSinglePaymentReceived.holderName != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                  <InputText
                    type="text"
                    class="form-control float-class"
                    id=""
                    maxlength="100"
                    v-model="aSinglePaymentReceived.holderName"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Cheque Holder Name<span style="color: red"> *</span></label
                  >
                </span>
              </div>
              <div
                class="form-group"
                :class="[
                  aSinglePaymentReceived.comment != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                  <InputText
                    class="form-control float-class"
                    id=""
                    maxlength="255"
                    v-model="aSinglePaymentReceived.comment"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Comment<span style="color: red"> *</span>:</label
                  >
                </span>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              id="chequePayment"
              @click="paymentReceivedClick('cheque')"
            >
              Collect
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- payment method modal -->

 <Dialog
      v-model:visible="displayPayMethod"
      style="width: 30%; max-height: 100%"
      @hide="closeModalRem()"
      position="top"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Select A Payment Method</h4>
      </template>
      <form>
        <div class="row text-center">
          <div class="col m-2 p-2">
            <a href="javascript:void(0)" @click="showSubmitPaymentModal(1)">
              <i class="far fa-credit-card fa-5x mb-3 blue-text"></i>
              <h4 class="font-weight-bold">Credit Or Debit Card</h4>
            </a>
          </div>

          <div class="col m-2 p-2">
            <a href="javascript:void(0)" @click="showSubmitPaymentModal(2)">
              <i class="fas fa-hand-holding-usd fa-5x mb-3 blue-text"></i>
              <h4 class="font-weight-bold">Cash</h4>
            </a>
          </div>

          <div class="col m-2 p-2">
            <a href="javascript:void(0)" @click="showSubmitPaymentModal(3)">
              <i class="fas fa-money-check-alt fa-5x mb-3 blue-text"></i>
              <h4 class="font-weight-bold">Cheque</h4>
            </a>
          </div>
        </div>
      </form>
    </Dialog>

  <div
      id="emailDetails"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-lg-12">
                  <div class="card">
                    <div class="row">
                      <div class="card-body p-t-0">
                        <div class="card b-all shadow-none">
                          <div class="card-body">
                            <h3 class="card-title m-b-0">
                              {{ subject }}
                            </h3>
                          </div>
                          <div>
                            <hr class="m-t-0" />
                          </div>
                          <div class="card-body">
                            <div class="d-flex m-b-40">
                              <div>
                                <!-- <a
                                  class="
                                    nav-link
                                    dropdown-toggle
                                    waves-effect waves-dark
                                    profile-pic
                                  "
                                  href=""
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                > -->
                                  <img
                                    v-if="Image == ''"
                                    style="
                                      border-radius: 50%;
                                      height: 40px;
                                      width: 40px;
                                    "
                                    src="assets/images/profile.jpg"
                                   />
                                  <img
                                    v-else
                                    :src="Image"
                                    class=""
                                    style="
                                      border-radius: 50%;
                                      height: 40px;
                                      width: 40px;
                                    "
                                />
                              </div>
                              <div class="p-l-10">
                                <h4 class="m-b-0">
                                  {{
                                    aSinglePatient.firstName +
                                    " " +
                                    aSinglePatient.lastName
                                  }}
                                </h4>
                                <small class="text-muted"
                                  >to:
                                  <span
                                    class="__cf_email__"
                                    data-cfemail="e58f8a8b84918d848ba5818a88848c8bcb868a88"
                                  >
                                    {{ emailTo }}</span
                                  ></small
                                >
                              </div>
                            </div>
                            <p><b>Dear User</b></p>
                         <Editor
                          readonly
                          v-model="emailMessage"
                          editorStyle="height: 200px">
                           <template #toolbar>
                            <span class="ql-formats"> </span>
                          </template>
                        </Editor>
                            <!-- <p style="word-break: break-all">
                              {{ emailMessage }}
                            </p> -->
                          </div>
                          <div>
                            <hr class="m-t-0" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

      <!-- Reminder -->
    <div
      id="reminder"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Reminder</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div class="form-group m-b-40"
                 :class="[Reminder.email != null ? 'focused' : '']">
                <input
                  type="text"
                  v-model="Reminder.email"
                  class="form-control"
                  id=""
                /><span class="bar"></span>
                <label for="">Email<span style="color: red"> *</span></label>
              </div>
              <div class="form-group m-b-40"
                :class="[Reminder.phone != null ? 'focused' : '']">
                <input
                  v-mask="'###-###-####'"
                  type="tel"
                  v-model="Reminder.phone"
                  class="form-control"
                  id=""
                /><span class="bar"></span>
                <label for=""
                  >Phone Number<span style="color: red"> *</span></label
                >
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="sendReminderClick"
              class="btn btn-success waves-effect waves-light"
            >
              Send
            </button>
            <button
              type="button"
              class="btn btn-danger waves-effect waves-light"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Reminder -->
   
    <!-- **MergeModal -->
    <div
      id="mergeModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog cascading-modal modal-lg" role="document">
        <!-- Content -->
        <div
          class="modal-content"
          style="width:1200px;display: block;margin-left:-138px;"
        >
          <!--Modal cascading tabs-->
          <div class="modal-c-tabs">
            <!-- Nav tabs -->
            <ul class="nav md-tabs tabs-2 light-blue darken-3" role="tablist">
              <li class="nav-item" @click="mergeModalClickReloadChange()">
                <a
                  id="mappingClick"
                  class="nav-link white-text active show"
                  data-toggle="tab"
                  href="#veinsPanel"
                  role="tab"
                  aria-selected="false"
                  ><i class="fas fa-user-plus mr-1"></i> Suggested</a
                >
              </li>
              <li class="nav-item" @click="mergeModalClickReload1()">
                <a
                  class="nav-link white-text"
                  data-toggle="tab"
                  href="#myPatientPanel"
                  role="tab"
                  aria-selected="true"
                  ><i class="fas fa-user mr-1"></i> All Patients</a
                >
              </li>
            </ul>
            <!-- Tab panels -->
            <div class="tab-content">
              <!-- === Merge Patient Panel ALL ==== -->
              <div class="tab-pane fade" id="myPatientPanel" role="tabpanel">
                <!-- Body -->
                <div class="modal-body mb-1 pt-2">
                  <div class="table-responsive">
                    <table
                      class="table display table-bordered table-striped no-wrap"
                    >
                      <thead class="thead-dark">
                        <tr>
                          <th>PT ID</th>
                          <th>External Id</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>DOB</th>
                          <th>Email</th>
                          <th>Phone</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <button
                              class="
                                btn btn-facebook btn-sm
                                waves-effect waves-light
                              "
                              type="button"
                            >
                              {{ aSinglePatient.ptid }}
                            </button>
                          </td>
                          <td>{{ aSinglePatient.externalId }}</td>
                          <td>{{ aSinglePatient.firstName }}</td>
                          <td>{{ aSinglePatient.lastName }}</td>
                          <td>{{ aSinglePatient.dob }}</td>
                          <td>
                            {{ aSinglePatient.email }}
                            <!-- <span
                              class="__cf_email__"
                              data-cfemail="b3cbf3d4ded2dadf9dd0dcde"
                              >[email&#160;protected]</span
                            > -->
                          </td>
                          <td>{{ aSinglePatient.phone }}</td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- class="btn btn-outline-info col-12" -->
                    <div class="container">
                      <div class="row mt-3 mb-3">
                        <button
                          type="button"
                          class="btn btn-outline-info col-12"
                          @click="newPatientClick"
                          :disabled="aSinglePatient.patientId > 0"
                        >
                          This is a New Patient
                        </button>
                      </div>
                    </div>

                    <hr class="solid text-black-50" />

                    <div class="row">
                      <div class="col-1">
                        <div class="form-group">
                          <span class="p-float-label">
                            <InputText
                              type="text"
                              id=""
                              placeholder=""
                              v-model="suggested1.searchVeinsId"
                              @change="applyDateClickSuggested1()"
                              style="width: 100%"
                            />
                            <label id="font1">PT ID</label>
                          </span>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="form-group">
                          <span class="p-float-label">
                            <InputText
                              type="text"
                              id=""
                              placeholder=""
                              v-model="suggested1.searchExternalId"
                              @change="applyDateClickSuggested1()"
                              style="width: 100%"
                            />
                            <label id="font1">External ID</label>
                          </span>
                        </div>
                      </div>

                      <div class="col-2">
                        <div class="form-group">
                          <span class="p-float-label">
                            <InputText
                              type="text"
                              id=""
                              placeholder=""
                              maxlength="50"
                              v-model="suggested1.searchFirstName"
                              @change="applyDateClickSuggested1()"
                              style="width: 100%"
                            />
                            <label id="font1">First Name</label>
                          </span>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="form-group">
                          <span class="p-float-label">
                            <InputText
                              type="text"
                              id=""
                              placeholder=""
                              maxlength="50"
                              v-model="suggested1.searchLastName"
                              @change="applyDateClickSuggested1()"
                              style="width: 100%"
                            />
                            <label id="font1">Last Name</label>
                          </span>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="form-group">
                          <span class="p-float-label">
                            <InputText
                              v-mask="'###-###-####'"
                              type="tel"
                              id=""
                              placeholder=""
                              v-model="suggested1.searchPhone"
                              @change="applyDateClickSuggested1()"
                              style="width: 100%"
                            />
                            <label id="font1">Phone</label>
                          </span>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="form-group">
                          <span class="p-float-label">
                            <InputText
                              type="date"
                              id=""
                              placeholder=""
                              v-model="suggested1.Dob"
                              @change="applyDateClickSuggested1()"
                              style="width: 100%"
                            />
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="table-responsive">
                      <div
                        class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
                      >
                        <div class="dataTables_length">
                          <span style="margin-right: 10px"
                            ><label for="">Show </label>
                          </span>
                          <select
                            v-model="pageSize"
                            class="form-control form-control-sm"
                            aria-label="Default select example"
                            @change="pageChangeSuggested1(1)"
                          >
                            <option selected>50</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                            <option value="1000">1000</option>
                            <option value="2000">2000</option>
                          </select>

                          <span style="margin-left: 10px">
                            <label for=""> Entries </label></span
                          >
                        </div>
                      </div>
                      <table
                        class="
                table
                display
                table-bordered
                text-center
                table-striped
                no-wrap
              "
                        id="home_22"
                      >
                        <thead class="thead-dark">
                          <tr>
                            <th style="text-align: start">
                              PT ID<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="orderBySuggested1(1)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              External Id<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="orderBySuggested1(2)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              First Name<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="orderBySuggested1(3)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Last Name<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="orderBySuggested1(4)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              DOB<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="orderBySuggested1(5)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Email<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="orderBySuggested1(6)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Phone<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="orderBySuggested1(7)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="suggestedPatients1.length == 0">
                            <td align="center" colspan="100">
                              <strong> No data available</strong>
                            </td>
                          </tr>
                          <tr
                            v-for="(pat1, ndx041) in suggestedPatients1"
                            :key="ndx041"
                          >
                            <td>
                              <button
                                class="
                                  btn btn-facebook btn-sm
                                  waves-effect waves-light
                                "
                                type="button"
                                @click="alertModalClick_Suggested(pat1)"
                              >
                                {{ pat1.ptid }}
                              </button>
                            </td>
                            <td>{{ pat1.externalId }}</td>
                            <td>{{ pat1.firstName }}</td>
                            <td>{{ pat1.lastName }}</td>
                            <td>{{ pat1.dob }}</td>
                            <td>
                              {{ pat1.email }}
                            </td>
                            <td>{{ pat1.phone }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                     <nav aria-label="Page navigation">
                      <span
                        style="padding-left: 40px"
                        v-if="
                          totalRowsSuggest1 <
                            pageSizeSuggest1 * pageNumberSuggest1
                        "
                        >showing {{ totalRowsSuggest1 }} of
                        {{ totalRowsSuggest1 }} records</span
                      >
                      <span style="padding-left: 40px" v-else
                        >showing {{ pageSizeSuggest1 * pageNumberSuggest1 }} of
                        {{ totalRowsSuggest1 }} records</span
                      >
                      <ul class="pagination" style="float: right">
                        <li class="page-item colorActive">
                          <span v-if="pageNumberSuggest1 == 1">
                            <button
                              disabled
                              class="page-link disabledColor"
                              @click="pageChangeSuggested1('Previous')"
                            >
                              Previous
                            </button>
                          </span>
                          <span v-else>
                            <button
                              class="page-link"
                              @click="pageChangeSuggested1('Previous')"
                            >
                              Previous
                            </button>
                          </span>
                        </li>
               <!--show pagination--> 
                <li v-if="showPagesMin1 > 1">
                 <button class="page-link" @click="pageChangeSuggested1(1)">
                    1
                  </button>
                </li>
                 <li v-if="showPagesMin1>1 ">
                 <button
                    disabled
                    class="page-link disabledColor"
                  >
                    ...
                    </button>
                 </li>
                  <!--show pagination--> 
                        <li
                          v-for="pageNumSugg1 in totalPagesSuggest1"
                          :key="pageNumSugg1"
                          class="page-item colorActive"
                        >
                          <span v-if="pageNumSugg1 >= showPagesMin1 && pageNumSugg1 <= showPagesMax1"> 
                          <span v-if="pageNumberSuggest1 == pageNumSugg1"
                            ><button
                              class="page-link activeColor"
                              disabled
                              @click="pageChangeSuggested1(pageNumSugg1)"
                            >
                              {{ pageNumSugg1 }}
                            </button>
                          </span>
                          <span v-else>
                            <button
                              class="page-link"
                              @click="pageChangeSuggested1(pageNumSugg1)"
                            >
                              {{ pageNumSugg1 }}
                            </button>
                            </span>
                            </span>
                        </li>
            <!--show pagination-->          
              <li v-if="totalPagesSuggest1 > 10 && (totalPagesSuggest1-4) >= pageNumber">
                 <button
                    disabled
                    class="page-link disabledColor"
                  >
                    ...
                  </button>
              </li>
             <li v-if="totalPagesSuggest1 > 10 &&  (totalPagesSuggest1-4) >= pageNumberSuggest1">
                 <button class="page-link" @click="pageChangeSuggested1(totalPagesSuggest1)">
                    {{ totalPagesSuggest1 }}
                  </button>
             </li>
               <!--show pagination-->   
                        <li class="page-item colorActive">
                          <span v-if="pageNumberSuggest1 == totalPagesSuggest1">
                            <button
                              disabled
                              class="page-link disabledColor"
                              @click="pageChangeSuggested1('Next')"
                            >
                              Next
                            </button>
                          </span>
                          <span v-else>
                            <button
                              class="page-link"
                              @click="pageChangeSuggested1('Next')"
                            >
                              Next
                            </button>
                          </span>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>

                <!-- Footer -->
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-outline-info waves-effect ml-auto"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
                <!-- Footer -->
              </div>
              <!-- === Merge Patient Panel ==== -->

              <!-- === Veins Patient - Suggested === -->
              <div
                class="tab-pane fade in active show"
                id="veinsPanel"
                role="tabpanel"
              >
                <!-- Body -->
                <div class="modal-body mb-1 pt-2">
                  <div class="table-responsive">
                    <table
                      class="table display table-bordered table-striped no-wrap"
                    >
                      <thead class="thead-dark">
                        <tr>
                          <th>PT ID</th>
                          <th>External Id</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>DOB</th>
                          <th>Email</th>
                          <th>Phone</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <button
                              class="
                                btn btn-facebook btn-sm
                                waves-effect waves-light
                              "
                              type="button"
                            >
                              {{ aSinglePatient.ptid }}
                            </button>
                          </td>
                          <td>{{ aSinglePatient.externalId }}</td>
                          <td>{{ aSinglePatient.firstName }}</td>
                          <td>{{ aSinglePatient.lastName }}</td>
                          <td>{{ aSinglePatient.dob }}</td>
                          <td>
                            {{ aSinglePatient.email }}
                            <!-- <span
                              class="__cf_email__"
                              data-cfemail="b3cbf3d4ded2dadf9dd0dcde"
                              >[email&#160;protected]</span
                            > -->
                          </td>
                          <td>{{ aSinglePatient.phone }}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div v-if="updButton == 1" class="container">
                      <div class="row mt-3 mb-3">
                        <button
                          type="button"
                          :class="
                            aSinglePatient.patientId > 0
                              ? 'btn btn-outline-secondary waves-effect col-12'
                              : 'btn btn-outline-info waves-effect col-12'
                          "
                          :disabled="aSinglePatient.patientId > 0"
                          @click="newPatientClick"
                        >
                          This is a New Patient
                        </button>
                      </div>
                    </div>

                    <div v-else class="container">
                      <div class="row mt-3 mb-3">
                        <button
                          type="button"
                          :class="
                            aSinglePatient.patientId > 0
                              ? 'btn btn-outline-secondary waves-effect col-12'
                              : 'btn btn-outline-info waves-effect col-12'
                          "
                          :disabled="updButton == 0"
                          @click="newPatientClick"
                        >
                          This is a New Patient
                        </button>
                      </div>
                    </div>

                    <!-- <div v-if="suggestedPatients.length > 0"> -->
                    <hr class="solid text-black-50" />

                    <div class="row">
                      <div class="col-12">
                        <form class="floating-labels">
                          <legend class="text-center" style="font-weight: 900">
                            These are some suggested profiles we found...
                          </legend>
                        </form>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-1">
                        <div class="form-group">
                          <span class="p-float-label">
                            <InputText
                              type="text"
                              id=""
                              placeholder=""
                              v-model="suggested.searchVeinsId"
                              @change="applyDateClickSuggested()"
                              style="width: 100%"
                            />
                            <label id="font1">PT ID</label>
                          </span>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="form-group">
                          <span class="p-float-label">
                            <InputText
                              type="text"
                              id=""
                              placeholder=""
                              v-model="suggested.searchExternalId"
                              @change="applyDateClickSuggested()"
                              style="width: 100%"
                            />
                            <label id="font1">External ID</label>
                          </span>
                        </div>
                      </div>

                      <div class="col-2">
                        <div class="form-group">
                          <span class="p-float-label">
                            <InputText
                              type="text"
                              id=""
                              placeholder=""
                              maxlength="50"
                              v-model="suggested.searchFirstName"
                              @change="applyDateClickSuggested()"
                              style="width: 100%"
                            />
                            <label id="font1">First Name</label>
                          </span>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="form-group">
                          <span class="p-float-label">
                            <InputText
                              type="text"
                              id=""
                              placeholder=""
                              maxlength="50"
                              v-model="suggested.searchLastName"
                              @change="applyDateClickSuggested()"
                              style="width: 100%"
                            />
                            <label id="font1">Last Name</label>
                          </span>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="form-group">
                          <span class="p-float-label">
                            <InputText
                              v-mask="'###-###-####'"
                              type="tel"
                              id=""
                              placeholder=""
                              v-model="suggested.searchPhone"
                              @change="applyDateClickSuggested()"
                              style="width: 100%"
                            />
                            <label id="font1">Phone</label>
                          </span>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="form-group">
                          <span class="p-float-label">
                            <InputText
                              type="date"
                              id=""
                              placeholder=""
                              v-model="suggested.Dob"
                              @change="applyDateClickSuggested()"
                              style="width: 100%"
                            />
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="table-responsive">
                      <div
                        class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
                      >
                        <div class="dataTables_length">
                          <span style="margin-right: 10px"
                            ><label for="">Show </label>
                          </span>
                          <select
                            v-model="pageSize"
                            class="form-control form-control-sm"
                            aria-label="Default select example"
                            @change="pageChangeSuggested(1)"
                          >
                            <option selected>50</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                            <option value="1000">1000</option>
                            <option value="2000">2000</option>
                          </select>

                          <span style="margin-left: 10px">
                            <label for=""> Entries </label></span
                          >
                        </div>
                      </div>
                      <table
                        class="
                table
                display
                table-bordered
                text-center
                table-striped
                no-wrap
              "
                        id="home_2"
                      >
                        <thead class="thead-dark">
                          <tr>
                            <th style="text-align: start">
                              PT ID<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="orderBySuggested(1)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              External Id<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="orderBySuggested(2)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              First Name<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="orderBySuggested(3)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Last Name<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="orderBySuggested(4)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              DOB<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="orderBySuggested(5)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Email<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="orderBySuggested(6)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Phone<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="orderBySuggested(7)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="suggestedPatients.length == 0">
                            <td align="center" colspan="100">
                              <strong> No data available</strong>
                            </td>
                          </tr>
                          <tr
                            v-for="(pat, ndx04) in suggestedPatients"
                            :key="ndx04"
                          >
                            <td>
                              <button
                                class="
                                  btn btn-facebook btn-sm
                                  waves-effect waves-light
                                "
                                type="button"
                                @click="alertModalClick_Suggested(pat)"
                              >
                                {{ pat.ptid }}
                              </button>
                            </td>
                            <td>{{ pat.externalId }}</td>
                            <td>{{ pat.firstName }}</td>
                            <td>{{ pat.lastName }}</td>
                            <td>{{ pat.dob }}</td>
                            <td>
                              {{ pat.email }}
                            </td>
                            <td>{{ pat.phone }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                      <nav aria-label="Page navigation">
                      <span
                        style="padding-left: 40px"
                        v-if="
                          totalRowsSuggest < pageSizeSuggest * pageNumberSuggest
                        "
                        >showing {{ totalRowsSuggest }} of
                        {{ totalRowsSuggest }} records</span
                      >
                      <span style="padding-left: 40px" v-else
                        >showing {{ pageSizeSuggest * pageNumberSuggest }} of
                        {{ totalRowsSuggest }} records</span
                      >
                      <ul class="pagination" style="float: right">
                        <li class="page-item colorActive">
                          <span v-if="pageNumberSuggest == 1">
                            <button
                              disabled
                              class="page-link disabledColor"
                              @click="pageChangeSuggested('Previous')"
                            >
                              Previous
                            </button>
                          </span>
                          <span v-else>
                            <button
                              class="page-link"
                              @click="pageChangeSuggested('Previous')"
                            >
                              Previous
                            </button>
                          </span>
                        </li>
                <!--show pagination--> 
                <li v-if="showPagesMin11 > 1">
                 <button class="page-link" @click="pageChangeSuggested(1)">
                    1
                  </button>
                </li>
                 <li v-if=" showPagesMin11>1 ">
                 <button
                    disabled
                    class="page-link disabledColor"
                  >
                    ...
                    </button>
                 </li>
                  <!--show pagination--> 
                        <li
                          v-for="pageNumSugg in totalPagesSuggest"
                          :key="pageNumSugg"
                          class="page-item colorActive"
                        >
                          <span v-if="pageNumSugg >= showPagesMin11 && pageNumSugg <= showPagesMax11"> 
                          <span v-if="pageNumberSuggest == pageNumSugg"
                            ><button
                              class="page-link activeColor"
                              disabled
                              @click="pageChangeSuggested(pageNumSugg)"
                            >
                              {{ pageNumSugg }}
                            </button>
                          </span>
                          <span v-else>
                            <button
                              class="page-link"
                              @click="pageChangeSuggested(pageNumSugg)"
                            >
                              {{ pageNumSugg }}
                            </button></span
                          >
                          </span>
                        </li>
           <!--show pagination-->          
              <li v-if="totalPagesSuggest > 10 && (totalPagesSuggest-4) >= pageNumberSuggest">
                 <button
                    disabled
                    class="page-link disabledColor"
                  >
                    ...
                  </button>
              </li>
             <li v-if="totalPagesSuggest > 10 &&  (totalPagesSuggest-4) >= pageNumberSuggest">
                 <button class="page-link" @click="pageChangeSuggested(totalPagesSuggest)">
                    {{ totalPagesSuggest }}
                  </button>
             </li>
               <!--show pagination-->   
                        <li class="page-item colorActive">
                          <span v-if="pageNumberSuggest == totalPagesSuggest">
                            <button
                              disabled
                              class="page-link disabledColor"
                              @click="pageChangeSuggested('Next')"
                            >
                              Next
                            </button>
                          </span>
                          <span v-else>
                            <button
                              class="page-link"
                              @click="pageChangeSuggested('Next')"
                            >
                              Next
                            </button>
                          </span>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <!-- <div v-else>
                      <hr class="solid text-black-50" />
                      <div class="row">
                        <div class="col-12">
                          <form class="floating-labels">
                            <legend
                              class="text-center"
                              style="font-weight: 900"
                            >
                              No suggestion(s) found...
                            </legend>
                          </form>
                        </div>
                    </div>
                  </div> -->
                  <!-- </div> -->
                </div>
              </div>
              <!-- === Veins Patient === -->
            </div>
          </div>
        </div>
        <!-- Content -->
      </div>
    </div>
    <!-- Merge Modal -->

    <!-- Alert Modal -->
    <div
      class="modal bs-example-modal-lg fade"
      id="alertModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      style="display: none; overflow-y: scroll"
    >
      <div class="modal-dialog col-12" style="max-width: none">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Merge Patients</h4>
          </div>

          <div class="row">
            <div class="col-6">
              <button
                type="button"
                class="btn btn-outline-success waves-effect waves-light col-12"
                style="margin-left: 5px"
                id="model-merge0"
                :disabled="updButton == 0"
                @click="mergeContinueClick"
              >
                Continue
              </button>
            </div>
            <div class="col-6">
              <button
                type="button"
                class="btn btn-outline-danger waves-effect waves-light col-12"
                style="margin-right: 25px; important"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div class="row">
                <div class="col-3">
                  <p
                    class="text-center font-weight-bold"
                    style="font-size: 20px"
                  >
                    &nbsp;&nbsp;
                  </p>
                  <div class="form-group m-b-40">
                    <table
                      class="table display table-bordered table-striped no-wrap"
                    >
                      <thead class="thead-dark">
                        <tr>
                          <th>PT ID</th>
                        </tr>
                      </thead>
                      <tbody style="font-weight: 900">
                        <tr>
                          <td>First Name</td>
                        </tr>
                        <tr>
                          <td>Last Name</td>
                        </tr>
                        <tr>
                          <td>DOB</td>
                        </tr>
                        <tr>
                          <td>Gender</td>
                        </tr>
                        <tr>
                          <td>Phone Number</td>
                        </tr>
                        <tr>
                          <td>Email</td>
                        </tr>
                        <tr>
                          <td>External ID</td>
                        </tr>
                        <tr>
                          <td>Social Security Number</td>
                        </tr>
                        <tr>
                          <td>Street</td>
                        </tr>
                        <tr>
                          <td>City</td>
                        </tr>
                        <tr>
                          <td>State</td>
                        </tr>
                        <tr>
                          <td>Zip</td>
                        </tr>
                        <tr>
                          <td>Primary Insurance</td>
                        </tr>
                        <tr>
                          <td>Primary Insurance Number</td>
                        </tr>
                        <tr>
                          <td>Primary Insurance Group ID</td>
                        </tr>
                        <tr>
                          <td>Primary Insurance ID</td>
                        </tr>
                        <tr>
                          <td>Secondary Insurance</td>
                        </tr>
                        <tr>
                          <td>Secondary Insurance Number</td>
                        </tr>
                        <tr>
                          <td>Secondary Insurance Group ID</td>
                        </tr>
                        <tr>
                          <td>Secondary Insurance ID</td>
                        </tr>
                        <tr>
                          <td>Visits</td>
                        </tr>
                        <tr>
                          <td>Payments</td>
                        </tr>
                        <tr>
                          <td>Emails</td>
                        </tr>
                        <tr>
                          <td>Texts</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="col-lg-3 col-sm-12 col-md-6">
                  <p
                    class="text-center font-weight-bold"
                    style="font-size: 20px"
                  >
                    Active Patient
                  </p>
                  <div class="form-group m-b-40">
                    <table
                      class="table display table-bordered table-striped no-wrap"
                    >
                      <thead class="thead-dark">
                        <tr>
                          <th>{{ aSinglePatient.ptid }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style="word-break: break-all">
                            {{ aSinglePatient.firstName }}
                          </td>
                        </tr>
                        <tr>
                          <td style="word-break: break-all">
                            {{ aSinglePatient.lastName }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ aSinglePatient.dob }}</td>
                        </tr>
                        <tr>
                          <td>{{ aSinglePatient.gender }}</td>
                        </tr>
                        <tr>
                          <td>{{ aSinglePatient.phone }}</td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSinglePatient.email }}
                            <!-- <span
                              class="__cf_email__"
                              data-cfemail="f68597988597849fc4b6919b979f9ad895999b"
                              >[email&#160;protected]</span
                            > -->
                          </td>
                        </tr>
                        <tr>
                          <td>{{ aSinglePatient.externalId }}</td>
                        </tr>
                        <tr>
                          <td>{{ aSinglePatient.ssn }}</td>
                        </tr>
                        <tr>
                          <td style="word-break: break-all">
                            {{ aSinglePatient.streetAddress }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ aSinglePatient.city }}</td>
                        </tr>
                        <tr>
                          <td>{{ aSinglePatient.state }}</td>
                        </tr>
                        <tr>
                          <td>{{ aSinglePatient.zip }}</td>
                        </tr>
                        <tr>
                          <td>
                            {{ insurance.primaryInsurance }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ insurance.primaryInsuranceNo }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ insurance.primaryInsuranceGroupId }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ insurance.primaryInsuranceId }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ insurance.secondaryInsurance }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ insurance.secondaryInsuranceNo }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ insurance.secondaryInsuranceGroupId }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ insurance.secondaryInsuranceId }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSinglePatient.stats.visits }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSinglePatient.stats.payments }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSinglePatient.stats.emails }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSinglePatient.stats.texts }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="col-lg-3 col-sm-12 col-md-6">
                  <p
                    class="text-center font-weight-bold"
                    style="font-size: 20px"
                  >
                    Selected Patient {{ aSelectedPatient.ptid }}
                  </p>
                  <div class="form-group m-b-40">
                    <table
                      class="table display table-bordered table-striped no-wrap"
                    >
                      <thead class="thead-dark">
                        <tr>
                          <th>{{ aSelectedPatient.ptid }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style="word-break: break-all">
                            {{ aSelectedPatient.firstName }}
                          </td>
                        </tr>
                        <tr>
                          <td style="word-break: break-all">
                            {{ aSelectedPatient.lastName }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ aSelectedPatient.dob }}</td>
                        </tr>
                        <tr>
                          <td>{{ aSelectedPatient.gender }}</td>
                        </tr>
                        <tr>
                          <td>{{ aSelectedPatient.phone }}</td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSelectedPatient.email }}
                            <!-- <span
                              class="__cf_email__"
                              data-cfemail="f68597988597849fc4b6919b979f9ad895999b"
                              >[email&#160;protected]</span
                            > -->
                          </td>
                        </tr>
                        <tr>
                          <td>{{ aSelectedPatient.externalId }}</td>
                        </tr>
                        <tr>
                          <td>{{ aSelectedPatient.ssn }}</td>
                        </tr>
                        <tr>
                          <td style="word-break: break-all">
                            {{ aSelectedPatient.streetAddress }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ aSelectedPatient.city }}</td>
                        </tr>
                        <tr>
                          <td>{{ aSelectedPatient.state }}</td>
                        </tr>
                        <tr>
                          <td>{{ aSelectedPatient.zip }}</td>
                        </tr>
                        <tr>
                          <td>{{ aSelectedInsurance.primaryInsurance }}</td>
                        </tr>
                        <tr>
                          <td>{{ aSelectedInsurance.primaryInsuranceNo }}</td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSelectedInsurance.primaryInsuranceGroupId }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSelectedInsurance.primaryInsuranceId }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ aSelectedInsurance.secondaryInsurance }}</td>
                        </tr>
                        <tr>
                          <td>{{ aSelectedInsurance.secondaryInsuranceNo }}</td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSelectedInsurance.secondaryInsuranceGroupId }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSelectedInsurance.secondaryInsuranceId }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSelectedCounts.VisitCounts }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSelectedCounts.PaymentCounts }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSelectedCounts.EmailCounts }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSelectedCounts.TextCounts }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="col-lg-3 col-sm-12 col-md-6">
                  <p
                    class="text-center font-weight-bold"
                    style="font-size: 20px"
                  >
                    Merged Patient
                  </p>
                  <div class="form-group m-b-40">
                    <table
                      id="mainTable999"
                      class="
                        table
                        editable-table
                        table-bordered table-striped
                        m-b-0
                      "
                      style="cursor: pointer"
                    >
                      <thead class="thead-dark">
                        <tr>
                          <th>{{ aSinglePatient.ptid }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <!-- **777** -->

                          <!-- <td>{{ aSinglePatient.firstName }}</td> -->
                          <td style="word-break: break-all">
                            <input
                              :style="mergePatientInputStyle()"
                              type="text"
                              v-model="mergedPat.firstName"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td style="word-break: break-all">
                            <input
                              :style="mergePatientInputStyle()"
                              type="text"
                              v-model="mergedPat.lastName"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              :style="mergePatientInputStyle()"
                              type="date"
                              v-model="mergedPat.dob"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <select
                              :style="mergePatientInputStyle()"
                              tabindex="1"
                              v-model="mergedPat.gender"
                            >
                              <option value="0">Choose a Gender</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="Others">Others</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              v-mask="'###-###-####'"
                              type="tel"
                              id="phonenumber"
                              :style="mergePatientInputStyle()"
                              v-model="mergedPat.phone"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              type="text"
                              id=""
                              :style="mergePatientInputStyle()"
                              v-model="mergedPat.email"
                            />
                            <!-- <span
                              class="__cf_email__"
                              data-cfemail="f68597988597849fc4b6919b979f9ad895999b"
                              >[email&#160;protected]</span
                            > -->
                          </td>
                        </tr>
                        <tr>
                          <td>{{ aSinglePatient.externalId }}</td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              v-mask="'###-###-###'"
                              type="tel"
                              :style="mergePatientInputStyle()"
                              v-model="mergedPat.ssn"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td style="word-break: break-all">
                            <input
                              :style="mergePatientInputStyle()"
                              type="text"
                              v-model="mergedPat.address"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              :style="mergePatientInputStyle()"
                              type="text"
                              v-model="mergedPat.city"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              :style="mergePatientInputStyle()"
                              type="text"
                              v-model="mergedPat.state"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              v-mask="'######'"
                              type="tel"
                              :style="mergePatientInputStyle()"
                              v-model="mergedPat.zip"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              :style="mergePatientInputStyle()"
                              type="text"
                              v-model="mergedPat.primaryIns"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              :style="mergePatientInputStyle()"
                              type="text"
                              v-model="mergedPat.primaryInsNo"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              disabled
                              :style="mergePatientInputStyle()"
                              type="text"
                              v-model="mergedPat.primaryInsGroupId"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              disabled
                              :style="mergePatientInputStyle()"
                              type="text"
                              v-model="mergedPat.primaryInsId"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              :style="mergePatientInputStyle()"
                              type="text"
                              v-model="mergedPat.secondIns"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              :style="mergePatientInputStyle()"
                              type="text"
                              v-model="mergedPat.secondInsNo"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              disabled
                              :style="mergePatientInputStyle()"
                              type="text"
                              v-model="mergedPat.secondInsGroupId"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              disabled
                              :style="mergePatientInputStyle()"
                              type="text"
                              v-model="mergedPat.secondInsId"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSinglePatient.stats.visits }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSinglePatient.stats.payments }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSinglePatient.stats.emails }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ aSinglePatient.stats.texts }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Alert Modal -->

    <!-- Compose Email Modal -->
    <div
      class="modal bs-example-modal-lg fade"
      id="sendEmail"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Mailbox</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="row">
                <div class="col-4 col-md-4">
                  <div class="row">
                    <div class="col-xl">
                      <div
                        class="list-group text-left"
                        id="list-tab"
                        role="tablist"
                      >
                        <a
                          style="word-break: break-all"
                          v-for="(email, ndxA03) in emailTempsList"
                          :key="ndxA03"
                          @click="emailTempsListClick(email)"
                          :class="selectedEmailTempClass(email)"
                          role="tab"
                          href="#list-home"
                          aria-selected="true"
                          ><i :class="selectedEmailTempIcon(email)"></i
                          >{{ email.name }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-8 col-md-8">
                  <form class="">
                    <div class="card-body">
                      <h3 class="card-title">Compose New Message</h3>
                      <div class="form-group">
                        <input
                          class="form-control"
                          placeholder="Template Name:"
                          maxlength="40"
                          v-model="aSingleEmail.name"
                        />
                      </div>
                      <div class="form-group">
                        <input
                          class="form-control"
                          placeholder="Send:"
                          maxlength="100"
                          v-model="aSinglePatient.email"
                        />
                      </div>
                      <div class="form-group">
                        <input
                          class="form-control"
                          placeholder="Subject:"
                          maxlength="100"
                          v-model="aSingleEmail.emailSubject"
                        />
                      </div>
                      <!-- <div class="form-group" v-if="false">
                        <textarea
                          v-model="aSingleEmail.emailText"
                          class="textarea_editor form-control"
                          rows="15"
                          placeholder="Enter text ..."
                        ></textarea>
                      </div> -->
                      <Editor
                        v-model="aSingleEmail.emailText"
                        editorStyle="height: 200px"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              :disabled="updButton == 0"
              @click="sendEmail()"
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
            >
              Send Email
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Compose Email Modal -->

<div
      id="displayReceipt"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Send Receipt to following details</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div class="form-group m-b-40"
                 :class="[SendReceiptRequest.Email != '' ? 'focused' : '']">
                <input
                  type="text"
                  v-model="SendReceiptRequest.Email"
                  class="form-control"
                  id=""
                /><span class="bar"></span>
                <label for="">Email<span style="color: red"> *</span></label>
              </div>
              <div class="form-group m-b-40"
               :class="[SendReceiptRequest.Phone != '' ? 'focused' : '']">
                <input
                  v-mask="'###-###-####'"
                  type="tel"
                  v-model="SendReceiptRequest.Phone"
                  class="form-control"
                  id=""
                /><span class="bar"></span>
                <label for=""
                  >Phone Number<span style="color: red"> *</span></label
                >
              </div>
            </form>
          </div>

       <div class="modal-footer">
            <button
              type="button"
              @click="sendReceiptClick"
              class="btn btn-success waves-effect waves-light"
            >
              Send
            </button>
            <button
              type="button"
              class="btn btn-danger waves-effect waves-light"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
       </div>
      </div>
    </div>

<div
      id="displayReceipt11"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Send Receipt to following details</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div class="form-group m-b-40"
               >
         <input  type="text" class="form-control" id="refund" tabindex="1"
          v-model="refundAmount"
         :placeholder="'Amount Refunded (In $$), can not be greater then $' + (ActivePaymentRequest.amount - ActivePaymentRequest.refundAmount)"
          aria-labelledby="cname" 
          :max="ActivePaymentRequest.amount" 
          @keypress="amountRefundCheck($event,refundAmount)"
         >
                </div>
            </form>
          </div>

       <div class="modal-footer">
            <button
              type="button"
              @click="refundPayment()"
              class="btn btn-success waves-effect waves-light"
            >
              Send
            </button>
            <button
              type="button"
              class="btn btn-danger waves-effect waves-light"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
       </div>
      </div>
    </div>

    <!-- SendText Modal -->
    <div
      class="modal bs-example-modal-lg fade"
      id="sendText"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Send a text</h4>
            <button type="button" class="close" @click="sendTextModalClose">
              ×
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="row">
                <div class="col-4 col-md-4">
                  <div class="row">
                    <div class="col-xl">
                      <div
                        class="list-group text-left"
                        id="list-tab"
                        role="tablist"
                      >
                        <a
                          style="word-break: break-all"
                          v-for="(sms, ndxA02) in smsTempsList"
                          :key="ndxA02"
                          @click="smsTempsListClick(sms)"
                          :class="selectedSmsTempClass(sms)"
                          id="list-home-list"
                          data-toggle="list"
                          href="#list-home"
                          role="tab"
                          aria-controls="home"
                          aria-selected="true"
                          ><i :class="selectedSmsTempIcon(sms)"></i>
                          {{ sms.name }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-8 col-md-8">
                  <form class="floating-labels m-t-40">
                    <div
                      class="form-group m-b-40"
                      :class="[aSingleSms.name.length > 0 ? 'focused' : '']"
                    >
                      <input
                        type="text"
                        class="form-control"
                        id="templateName"
                        maxlength="40"
                        v-model="aSingleSms.name"
                      /><span class="bar"></span>
                      <label for="templateName"
                        >Template Name<span style="color: red"> *</span></label
                      >
                    </div>
                    <div
                      class="form-group m-b-40"
                      :class="[aSinglePatient.phone != null ? 'focused' : '']"
                    >
                      <input
                        v-mask="'###-###-####'"
                        type="tel"
                        class="form-control"
                        id="to"
                        v-model="aSinglePatient.phone"
                      /><span class="bar"></span>
                      <label for="to"
                        >To<span style="color: red"> *</span></label
                      >
                    </div>
                    <div
                      class="form-group m-b-40"
                      :class="[aSingleSms.smsText.length > 0 ? 'focused' : '']"
                    >
                      <label for="comment-text" class="control-label"
                        >Type your text<span style="color: red"> *</span></label
                      >
                      <textarea
                        v-model="aSingleSms.smsText"
                        class="form-control"
                        id="comment-text"
                        maxlength="120"
                      ></textarea>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              :disabled="updButton == 0"
              id="SendTextSMS"
              class="btn btn-outline-success waves-effect waves-light col-12"
              @click="SendSms()"
            >
              Send Text
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Send a Text Modal -->
    
  </div>
</template>

<script>
import PatientsSearchComponent from "../VeinsTracker/PatientsSearchComponent.vue";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import PatientComponent from "../../components/PatientComponent.vue";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
export default {
  name: "PatientPortal",
  components: { PatientComponent,PatientsSearchComponent },
  data() {
    return {      
      showProfilePopupVar:true,
      patientIdProps:0,
      //refund
      refundAmount:"",
      //receipt
       SendReceiptRequest:{
        PatientId:0,
        VisitId:0,
        LocalDateTime:new Date,
        BillNo:0,
        PNDX:0,
        Email:"",
        Phone:"",
        DC:"",
      },
      //payment
      pageNumberPays: 1,
      pageSizePays: 50,
      totalPagesPays: 0,
      totalRowsPays: 0,
      filteredPaymentRequests: "",
      ActivePaymentRequest: {},
      limitAmount: 0,
      displayPayMethod: false,
      
       //paymentHistory
      PhpageNumber: 1,
      PhpageSize: 50,
      PhtotalRows:0,
      PhtotalPages:0,
      //paymentHistory
      //reminder
      Reminder: [],
      btnProColl: false,
          
      //Page
      VhpageNumber: 1,
      VhpageSize: 50,
      VhtotalRows:0,
      VhtotalPages:0,

      showPagesMin1:1,
      showPagesMax1:5,
      showPagesMin11:1,
      showPagesMax11:5,

      suggestedPatients1: [],
      //show pagination
      showPagesMin:1,
      showPagesMax:5,
      //show pagination
      aSingleText: {
        userId: "",
      },
      emailTo: "",
      subject: "",
      emailHisUser: "",
      textHistorySerch: [],
      modalDate: "",
      val11: "",
      val22: "",
      Image: "",
      val1: "",
      val2: "",
      date1: "",
      date2: "",
      //merge
      phone: "",
      email: "",
      ssn: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      primaryInsurance: "",
      primaryInsuranceNo: "",
      primaryInsuranceId: "",
      primaryInsuranceGroupId: "",
      secondInsurance: "",
      secondInsuranceNo: "",
      secondInsuranceId: "",
      secondInsuranceGroupId: "",
      
      //Data table Stage
      pageNumber: 1,
      pageSize: 50,
      totalPages: 0,
      Search: "",
      totalRows: 0,
      DataTable: {},

      EmployeeRolesStr: [],
      updButton: 1,
      delButton: 1,
      //loader
      loader: "",
      //Timer
      TimerObject: {},
      //-- Search
      startDate: "",
      endDate: "",
      startDate_1: "",
      endDate_1: "",
      allFilterPatients_1: [],
      allFilterVisitHist: [],
      allPatients: [],
      allInsurances: [],
      suggestedPatients: [],
      allRawPatients: [],
      allFilterPatients: [],
      allFilterPayHist: [],
      auditData: [],
      initDate_1: "",
      initDate: "",
      initDate_2: "",
      startDate_2: "",
      endDate_2: "",
      aSelectedPatient: "",
      aSelectedInsurance: "",
      filterFirstName: "",
      filterLastName: "",
      filterPhone: "",
      filterDate: "",
      TextSearch: "",
      filterTextSearch: [],
      // actives
      aSingleStage: "",
      activeStageNdx: -1,
      activeStep: -1,
      // Single Patient
      aSinglePatient: {
        stats: {
          visits: 0,
          payments: 0,
          texts: 0,
          emails: 0,
        },
        email: "",
        phone: "",
        insurance: {
          primaryInsurance: "",
          primaryInsuranceId: "",
          primaryInsuranceGroupId: "",
          secondaryInsurance: "",
          secondaryInsuranceId: "",
          secondaryInsuranceGroupId: "",
          primaryFilePath: "",
          secondaryFilePath: "",
        },
      },
      insurance: {
        pndx: 0,
        patientId: 0,
        primaryInsurance: "",
        primaryInsuranceNo: "",
        primaryInsuranceGroupId: "",
        primaryInsuranceId: "",
        secondaryInsurance: "",
        secondaryInsuranceNo: "",
        secondaryInsuranceGroupId: "",
        secondaryInsuranceId: "",
        primaryFilePath: "",
        secondaryFilePath: "",
      },
      userTexts: [],
      emailHistory: [],
      aSingleUserSmsHist: [],
      paymentHistory: [],
      requestPaymentsList: [],
      smsTempsList: [],
      aSinglePaymentReceived: {
        pndx: 0,
        patientId: 0,
        practiceId: 0,
        visitId: 0,
        billNo: 0,
        collectedBy: 0,
        paymentDate: new Date(),
        amount: 0,
        paymentMethod: "",
        holderName: "",
        tdNumber: "",
        cardCVC: "",
        comment: "",
        zip: "",
      },
      //SMS Send
      aSingleSms: {
        name: "",
        smsText: "",
      },
      chatSms: "",
      //Email Object Used to send Emails
      emailTempsList: [],
      aSingleEmail: {
        name: "",
        emailText: "",
        emailSubject: "",
      },
      // a Single request payment
      aSingleRequestPayment: {
        patientId: 0,
        amount: 0,
        email: "",
        phone: "",
        comment: "",
      },
      //payment status Text update list
      paymentStatus: [
        { text: "Sent", PValue: 1 },
        { text: "Pending", PValue: 2 },
        { text: "Disputed", PValue: 3 },
        { text: "Paid", PValue: 4 },
      ],
      visitQuests: [],
      visitDemo: [],
      textHistory: [],
      visitHistory: [],
      users: [],
      //-- Search
      mainSearch: {
        searchExternalId: "",
        searchFirstName: "",
        searchLastName: "",
        searchPhone: "",
        searchDate: "",
      },
      // merge
      VisitPayCounts: [],
      aSelectedCounts: [],
      mergedPat: {
        firstName: "",
        lastName: "",
        dob: "",
        gender: "",
        phone: "",
        email: "",
        ssn: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        primaryIns: "",
        primaryInsNo: "",
        primaryInsId: "",
        primaryInsGroupId: "",
        secondIns: "",
        secondInsNo: "",
        secondInsId: "",
        secondInsGroupId: "",
      },

      filterObj: {
        externalid: "",
        vid: "",
        firstname: "",
        lastname: "",
        phone: "",
        sdate: "",
        startDate: "",
        endDate: "",
        refreshData: false,
      },

      sortColumn: 0,
      sortColumnOption: 0,

      //-- Search
      suggested: {
        searchVeinsId: "",
        searchExternalId: "",
        searchFirstName: "",
        searchLastName: "",
        searchPhone: "",
        Dob: "",
        searchDate: null,
      },

      //-- Search
      suggested1: {
        searchVeinsId: "",
        searchExternalId: "",
        searchFirstName: "",
        searchLastName: "",
        searchPhone: "",
        Dob: "",
        searchDate: null,
      },

       filter: {
        veinsId: "",
        externalId: "",
        firstName: "",
        lastName: "",
        phone: "",
        startDate: "",
        endDate: "",
      },

      //Data table MergeSugg
      pageNumberSuggest: 1,
      pageSizeSuggest: 50,
      totalPagesSuggest: 0,
      totalRowsSuggest: 0,

      //Data table MergeSugg
      pageNumberSuggest1: 1,
      pageSizeSuggest1: 50,
      totalPagesSuggest1: 0,
      totalRowsSuggest1: 0,

      sortColumnSuggest1: 0,
      sortColumnOptionSuggest1: 0,
      sortColumnSuggest: 0,
      sortColumnOptionSuggest: 0,
    }; // return
  }, // data
  // ~~methods
  methods: {
    callAuditLogPatientId()
    {
      this.$refs.auditLogComponent.loadInitPatient(this.patientIdProps);
    },
    //Reconcile
     showReconcileModel(pay) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to Reconcile this Payment. This action cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.value) {
          this.intDummyComm();
          this.dummyComm.extras = pay.status;
          this.dummyComm.visitId = pay.visitId;
          this.dummyComm.patientId = pay.patientId;
          this.dummyComm.extras2 = pay.billNo;
          this.dummyComm.filter = "";

          const myData = {
            dc: this.dummyComm,
            filter: this.$store.state.filterSTGDSP,
            sortColumn: this.sortColumn,
            sortColumnOption: this.sortColumnOption,
          };

          const url = this.SERVER + "/VNSPRAAPI/Trackers/ReconcilePaymentById";
          this.axiosGetData(url, myData, 900);
        }
      });
    },

    //code for Data-Tables_
    pageChangePayment(obj) {
      if (obj == "Next") {
        if (this.pageNumberPays < this.totalPagesPays) {
          this.pageNumber += 1;
        }
      } else if (obj == "Previous" && this.pageNumberPays != 1) {
        this.pageNumberPays -= 1;
      } else {
        this.pageNumberPays = obj;
      }
      this.endDate = new Date();
      this.startDate = new Date();
      this.startDate.setDate(this.startDate.getDate() - 7);
      this.endDate.setDate(this.endDate.getDate() + 1);
      this.initDate =
        this.dateToMDY(this.startDate) + " - " + this.dateToMDY(this.endDate);

      this.intDummyComm();
      this.dummyComm.myTime = "range";
      this.dummyComm.extras1 = this.dateToYMD(this.startDate);
      this.dummyComm.extras2 = this.dateToYMD(this.endDate);
      this.dummyComm.pageNumber = this.pageNumberPays;
      this.dummyComm.pageSize = this.pageSizePays;

      const url =
        this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaymentRequestsListyId";
      this.axiosGetData(url, this.dummyComm, 8000);
    },
    //receipt
    sendReceipt(pay){
      $('#displayReceipt').modal("show");
      this.SendReceiptRequest.PatientId = pay.patientId;
      this.SendReceiptRequest.PracticeId = pay.pacticeId;
      this.SendReceiptRequest.Email = pay.email;
      this.SendReceiptRequest.Phone = pay.phone;
      this.SendReceiptRequest.BillNo = pay.billNo;  
      this.SendReceiptRequest.VisitId = pay.visitId;
      this.SendReceiptRequest.LocalDateTime = new Date;   
      this.SendReceiptRequest.PNDX = pay.pndx;
    },
    sendReceiptClick(){
      this.intDummyComm();
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      const url =
      this.SERVER + "/VNSPRAAPI/Payments/SendReceiptReminder";   
      const myData = this.SendReceiptRequest;
      myData.DC = this.dummyComm;
      this.axiosGetData(url, myData, 9002);
    },
    //refund
    showSubmitRefundModal(pay){
      this.ActivePaymentRequest = pay;
      this.refundMethodType = pay.paymentMethod;
      $('#displayReceipt11').modal("show");
    },
    amountRefundCheck(evt,val) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;     
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        //Beautiful
        val = val+String.fromCharCode(evt.keyCode)
        if(parseFloat(val) > (this.ActivePaymentRequest.amount - this.ActivePaymentRequest.refundAmount))
        {
          evt.preventDefault();
          return;
        }
        return true;
      }
    },
    showProfilPopUpBro(pat) {
      console.log(pat);
      this.showProfilePopupVar = true;
     
      this.$nextTick(() => {
        $("#newptModalCom").modal("show");    
        this.$refs.patientComponent.getPatientDataForPatientPortal(pat);  
        this.removeModalBackdrop();
      });   

    },
    removeModalBackdrop(){
      this.$nextTick(() => {
            debugger;
            $("#newptModalCom").on("shown.bs.modal", function (e) {
            $(document).off("focusin.modal");
        });
      });
    }, 
     refundPayment() {
      this.intDummyComm();
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      const url =
      this.SERVER + "/VNSPRAAPI/Payments/RefundPayment";
      const myData = { 
        DC: this.dummyComm,
        BillNo:this.ActivePaymentRequest.billNo,
        DateLocalTime: new Date,
        RefundMethod: this.refundMethodType,
        Amount: this.refundAmount        
      }
       this.axiosGetData(url, myData, 9003);
     },
     //payment Request
     getPaymentResTabl() {
      window.scrollTo(0, 0);
      this.intDummyComm();
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      const url =
      this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaymentRequestsListyId";
      const myData = this.dummyComm;
      this.$refs.cp.getPaymentResTable(this.aSinglePatient.visitId,this.aSinglePatient.patientId);   
     },
   colorStyle(status){
      if(status==1)//Requested
      {return 'background-color:#03a9f3 ;border-color:#03a9f3';}
      else if(status==2)//Pending
      {return 'background-color:#03a9f3 ;border-color:#03a9f3';}
      else if(status==3)//Disputed
      {return 'background-color:black; border-color:black';}
      else if(status==4)//Paid
      {return 'background-color:#00C292; border-color:#00C292';}
      else if(status==5)//ReFund
      {return 'background-color:#dc3f4e; border-color:#dc3f4e';}
      else if(status==6)//PartiallyRefunded
      {return 'background-color:#DFCE1D; border-color:#DFCE1D';}
      else if(status==7)//PartiallyPaid
      {return 'background-color:#03a9f3; border-color:#03a9f3';}
      else if(status==7)//Deleted
      {return 'background-color:#03a9f3; border-color:#03a9f3';}
      else if(status==9)//Reconciled
      {return 'background-color:#d19e01; border-color:#d19e01';}
    },
    paymentCollectMethodModal(pay){
      this.displayPayMethod = true;
      this.ActivePaymentRequest = pay;
      this.limitAmount = pay.amount;
      this.aSinglePaymentReceived.amount = this.ActivePaymentRequest.amount;
    },
    closeModalRem() {
      this.displayPayMethod = false;
    },
    showSubmitPaymentModal(methodType) {
      this.displayPayMethod = false;
      if(methodType==1)
      { $("#debit").modal("show"); }
      else if(methodType==2)
      { $("#cash").modal("show"); }
      else if(methodType==3)
      { $("#cheque").modal("show");} 
    },
    showReminderModel(pay) {
      $("#reminder").modal("show");
      this.Reminder = pay;
    },
     sendReminderClick() {
      if (this.Reminder.email == "") {
        this.showErrorToast("Email is require");
        return;
      }
      if (this.Reminder.phone == "") {
        this.showErrorToast("Phone is require");
        return;
      }

      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());

      const Reminder1 = {
        PNDX: this.Reminder.pndx,
        BillNo: this.Reminder.billNo,
        VisitId: this.Reminder.visitId,
        PatientId: this.Reminder.patientId,
        Amount: this.Reminder.amount,
        Email: this.Reminder.email,
        Phone: this.Reminder.phone,
      };

      const myData = { dc: this.dummyComm, pr: Reminder1 };
      const url = this.SERVER + "/VNSPRAAPI/Trackers/SendPaymntReminder";
      this.axiosGetData(url, myData, 9000);
    },
    deletePayment(pay) {
       Swal.fire({
        title: "Are you sure?",
        text:
         "You want to Delete this Payment. This action \n cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Delete",
      }).then((result) => {
        if (result.value) {
          this.intDummyComm();
          this.dummyComm.extras = pay.status;
          this.dummyComm.visitId = pay.visitId;
          this.dummyComm.patientId = pay.patientId;
          const obj = {
            DC:this.dummyComm,
            PR:pay
          };

          const url = this.SERVER + "/VNSPRAAPI/Trackers/DeletePayment";
          this.axiosGetData(url, obj, 9001);
        }
      });
    },
     //search
    applyDateClickSuggested() {
      const str = this.suggested.Dob;
      const arr = str.split("-");
      let three = arr[0].slice(0, 3);
      let two = arr[0].slice(0, 2);
      let one = arr[0].slice(0, 1);
      if (three === "000" || two === "00" || one === "0") {
        return;
      }
      
      this.pageNumberSuggest = 1;
      if(this.suggested.searchVeinsId == "" && this.suggested.searchExternalId == ""
       && this.suggested.searchFirstName == "" && this.suggested.searchLastName == ""
       && this.suggested.searchPhone == "" && this.suggested.Dob == ""){
         this.mergeModalClickReloadChange();
       }
       else{
         this.mergeModalClick1();
    }
  },
    applyDateClickSuggested1() {
      const str = this.suggested1.Dob;
      const arr = str.split("-");
      let three = arr[0].slice(0, 3);
      let two = arr[0].slice(0, 2);
      let one = arr[0].slice(0, 1);
      if (three === "000" || two === "00" || one === "0") {
        return;
      }

      this.pageNumberSuggest1 = 1;
      this.mergeModalClickReload1();
    },
    //code for Data Tables Merge
    pageChangeSuggested1(obj) {
      if (obj == "Next") {
        if (this.pageNumberSuggest1 < this.totalPagesSuggest1) {
          this.pageNumberSuggest1 += 1;
        }
      } else if (obj == "Previous" && this.pageNumberSuggest1 != 1) {
        this.pageNumberSuggest1 -= 1;
      } else {
        this.pageNumberSuggest1 = obj;
      }

        if((this.showPagesMax1/2) < (this.pageNumberSuggest1))
        {
          this.showPagesMin1 = this.pageNumberSuggest1-4;
          this.showPagesMax1 = this.pageNumberSuggest1+4;
        }
        else if((this.showPagesMin1/2)<(this.pageNumberSuggest1))
        {
          this.showPagesMin1 = this.pageNumberSuggest1-4;
          this.showPagesMax1 = this.pageNumberSuggest1+4 ;
          if(this.showPagesMax1<5)
          {
            this.showPagesMax1 = 5;
          }
        }
        else{
          this.showPagesMin1 = 1;
          this.showPagesMax1 = 5 ;
        }

      this.mergeModalClickReload1();
    },
    pageChangeSuggested(obj) {
      if (obj == "Next") {
        if (this.pageNumberSuggest < this.totalPagesSuggest) {
          this.pageNumberSuggest += 1;
        }
      } else if (obj == "Previous" && this.pageNumberSuggest != 1) {
        this.pageNumberSuggest -= 1;
      } else {
        this.pageNumberSuggest = obj;
      }

        if((this.showPagesMax11/2) < (this.pageNumberSuggest))
        {
          this.showPagesMin11 = this.pageNumberSuggest-4;
          this.showPagesMax11 = this.pageNumberSuggest+4;
        }
        else if((this.showPagesMin11/2)<(this.pageNumberSuggest))
        {
          this.showPagesMin11 = this.pageNumberSuggest-4;
          this.showPagesMax11 = this.pageNumberSuggest+4 ;
          if(this.showPagesMax11<5)
          {
            this.showPagesMax11 = 5;
          }
        }
        else{
          this.showPagesMin11 = 1;
          this.showPagesMax11 = 5 ;
        }
      this.mergeModalClickReloadChange();
    },
     mergeModalClickReload1() {
      if (this.aSinglePatient.ptid !== null) {
        this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g, "");
      }
      // this.val11 = this.aSinglePatient.dosdate.split("/")[0];
      // if (this.val11.length == 1) {
      //   this.val11 = "0" + this.val11;
      // }
      // this.val22 = this.aSinglePatient.dosdate.split("/")[2].substring(2, 4);

      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.pageNumber = this.pageNumberSuggest1;
      this.dummyComm.pageSize = this.pageSizeSuggest1;
      this.dummyComm.filter = "";

      //+++555+++/
      let startDate = "";
      let endDate = "";

     //debugger
      startDate = new Date(1805, 1, 1);
      endDate = new Date();

      const filter = {
        veinsId: this.suggested1.searchVeinsId,
        externalId: this.suggested1.searchExternalId,
        firstName: this.suggested1.searchFirstName,
        lastName: this.suggested1.searchLastName,
        phone: this.suggested1.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        Dob: this.suggested1.Dob,
        stageId: 0,
      };

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sortColumn: this.sortColumnSuggest1,
        sortColumnOption: this.sortColumnOptionSuggest1,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetAllPatsPage";
      this.axiosGetData(url, myData, 500);
    },
     mergeModalClickReloadChange() {
      if (this.aSinglePatient.ptid !== null) {
        this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g, "");
      }
      // this.val11 = this.aSinglePatient.dosdate.split("/")[0];
      // if (this.val11.length == 1) {
      //   this.val11 = "0" + this.val11;
      // }
      // this.val22 = this.aSinglePatient.dosdate.split("/")[2].substring(2, 4);

      this.intDummyComm();
      this.dummyComm.extras = "nFilter";
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.pageNumber = this.pageNumberSuggest;
      this.dummyComm.pageSize = this.pageSizeSuggest;
      this.dummyComm.filter = "";

      //+++555+++/
      let startDate = "";
      let endDate = "";
      var filter = {};
      startDate = new Date(1805, 1, 1);
      endDate = new Date();
      
      if(this.suggested.searchVeinsId == "" && this.suggested.searchExternalId == ""
       && this.suggested.searchFirstName == "" && this.suggested.searchLastName == ""
       && this.suggested.searchPhone == "" && this.suggested.Dob == ""){
       filter = {
        veinsId: this.suggested.searchVeinsId,
        externalId: "",
        firstName: this.aSinglePatient.firstName,
        lastName: this.aSinglePatient.lastName,
        phone: this.aSinglePatient.phone,
        email: this.aSinglePatient.email,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        Dob: this.dateToYMD(this.aSinglePatient.dob),
        stageId: 0,
      };
   }
       else{
       filter = {
        veinsId: this.suggested.searchVeinsId,
        externalId: this.suggested.searchExternalId,
        firstName: this.suggested.searchFirstName,
        lastName: this.suggested.searchLastName,
        phone: this.suggested.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        Dob: this.suggested.Dob,
        stageId: 0,
      };
    }

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sortColumn: this.sortColumnSuggest,
        sortColumnOption: this.sortColumnOptionSuggest,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetAllPatsPageSuggest";
      this.axiosGetData(url, myData, 400);
    },
    applySearchClick() {
      this.pageNumber = 1;
      this.loadInit();
      //if(!this.filterObj.refreshData) return;
    },

    async textHistoryClick() {
      this.aSingleText = {
        userId: "",
      };
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetTextHistoryByVisitId";
      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.textHistory = await this.mixinsAxiosGetData(url, this.dummyComm);
    },

    //Email info
    getEmailInfor(emailMessageShort, emailTo, subject) {
     //debugger
      this.GetUserImage();
      this.emailMessage = emailMessageShort;
      //this.emailMessageShort = emailMessageShort;
      this.emailTo = emailTo;
      this.subject = subject;
     //debugger
      $("#emailDetails").modal("show");
    },
    //For Image
    GetUserImage() {
      const str = localStorage.OSversion;
      const arr = str.split("<VEINS2021/>");
      var UserId1 = arr[0];
      const url =
        this.SERVER +
        "/VNSPRAAPI/Practices/GetUserProfilePics?UserProfileId=" +
        UserId1;
      this.axiosGetUserData11(url);
    },
    async axiosGetUserData11(Url) {
      console.log("GetData");
      await axios({
        method: "get",
        url: Url,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          this.Image = res.data;
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {});
    },
    handleRole() {
      this.EmployeeRolesStr = localStorage.EmployeeRolesStr;
      this.EmployeeRolesStr = JSON.parse(this.EmployeeRolesStr);
      if (this.EmployeeRolesStr.length > 0) {
        this.val = this.EmployeeRolesStr.filter(
          (i) => i.name == "Patient Portal"
        );
        if (this.val[0].canUpdate == 0) {
          this.updButton = 0;
        }
        if (this.val[0].canDelete == 0) {
          this.delButton = 0;
        }
      }
    },

    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },

    requestDeleteClick(pat) {
      Swal.fire({
        icon: "error",
        title: "Are you sure?",
        text:
          "you want to delete this visit and any information related to it.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
      }).then((result) => {
        if (result.value) {
          //const dd = new Date();
          this.intDummyComm();
          this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
         //debugger // eslint-disable-line no-debugger
          this.dummyComm.patientId = pat.patientId;
          this.dummyComm.visitId = pat.visitId;

          this.dummyComm.pageNumber = this.pageNumber;
          this.dummyComm.pageSize = this.pageSize;
          this.dummyComm.filter = "";

          const myData = {
            dc: this.dummyComm,
            filter: this.$store.state.filterSTGDSP,
            sortColumn: this.sortColumn,
            sortColumnOption: this.sortColumnOption,
          };
          const url = this.SERVER + "/VNSPRAAPI/Trackers/DelPatientPortal";
          this.axiosGetData(url, myData, 214);
        }
      });
    },
    mergePatientInputStyle() {
      return "background-color: transparent;border-style: none;width: 100%;margin: 0px;padding:0px;";
    },
    questOptionSelected(quest, opt) {
      quest.answer = opt.questOptionId;
    },
    orderByPay(column){
      this.orderByCol = column;
      if(column==1)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.pndx < b.pndx) ? 1 : ((b.pndx < a.pndx) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.pndx > b.pndx) ? 1 : ((b.pndx > a.pndx) ? -1 : 0))
        }
        
      }
      if(column==2)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.pndx < b.pndx) ? 1 : ((b.pndx < a.pndx) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.pndx > b.pndx) ? 1 : ((b.pndx > a.pndx) ? -1 : 0))
        }
      }
      if(column==3)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.pndx < b.pndx) ? 1 : ((b.pndx < a.pndx) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.pndx > b.pndx) ? 1 : ((b.pndx > a.pndx) ? -1 : 0))
        }
      }
      if(column==4)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.billNo < b.billNo) ? 1 : ((b.billNo < a.billNo) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.billNo > b.billNo) ? 1 : ((b.billNo > a.billNo) ? -1 : 0))
        }
      }
      if(column==5)
      {
      if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.pndx < b.pndx) ? 1 : ((b.pndx < a.pndx) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.pndx > b.pndx) ? 1 : ((b.pndx > a.pndx) ? -1 : 0))
        }
      }
      if(column==6)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.billDateStr < b.billDateStr) ? 1 : ((b.billDateStr < a.billDateStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.billDateStr > b.billDateStr) ? 1 : ((b.billDateStr > a.billDateStr) ? -1 : 0))
        }
      }
      if(column==7)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.billDateStr < b.billDateStr) ? 1 : ((b.billDateStr < a.billDateStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.billDateStr > b.billDateStr) ? 1 : ((b.billDateStr > a.billDateStr) ? -1 : 0))
        }
      }
     if(column==8)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.amount < b.amount) ? 1 : ((b.amount < a.amount) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.amount > b.amount) ? 1 : ((b.amount > a.amount) ? -1 : 0))
        }
      }
        if(column==9)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.amount < b.amount) ? 1 : ((b.amount < a.amount) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.amount > b.amount) ? 1 : ((b.amount > a.amount) ? -1 : 0))
        }
      }
        if(column==10)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.refundDateStr < b.refundDateStr) ? 1 : ((b.refundDateStr < a.refundDateStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.refundDateStr > b.refundDateStr) ? 1 : ((b.refundDateStr > a.refundDateStr) ? -1 : 0))
        }
      }
        if(column==11)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.comment < b.comment) ? 1 : ((b.comment < a.comment) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.filteredPaymentRequests =this.filteredPaymentRequests.sort((a,b) => (a.comment > b.comment) ? 1 : ((b.comment > a.comment) ? -1 : 0))
        }
      }
    },
    demoSaveClick() {
      for (var j = 0; j < this.visitDemo.length; j++) {
        // if(this.visitDemo[j].answer == "") {
        //     this.ShowWarning("All Questionnaire Input is require");
        //     return;
        // }
        if (this.visitDemo[j].questTypeName == "Phone Number") {
          if (this.visitDemo[j].answer.length < 12) {
            this.ShowWarning("Phone must be of 10 length");
            return;
          }
        }
        if (this.visitDemo[j].questTypeName == "Date") {
          if (!this.isValidateDate(this.visitDemo[j].answer)) {
            this.ShowWarning("Valid Date of Birth required");
            event.preventDefault();
            return;
          }
        }
        if (this.visitDemo[j].questTypeName == "Email") {
          if (this.visitDemo[j].answer != null) {
            if (!this.validEmail(this.visitDemo[j].answer)) {
              this.Validity(this.e);
            }
          }
        }
      }
      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      //this.dummyComm.extras = this.aSelectedPatient.patientId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdVisQue";
      const myData = {
        dc: this.dummyComm,
        quests: this.visitDemo,
      };
      this.axiosGetData(url, myData, 7);
    },
    collectPaymentButtonClass(rp) {
      if (rp.status == "4") return "btn btn-success";
      else return "btn btn-danger";
    },
    collectPaymentButtonClassDropDown(rp) {
      if (rp.status == "4")
        return "btn btn-success btn btn-success dropdown-toggle dropdown-toggle-split";
      else
        return "btn btn-success  btn btn-danger dropdown-toggle dropdown-toggle-split";
    },
    paymentReceivedClick(what) {
      const valueAmount = this.aSinglePaymentReceived.amount;

      if (what == "cheque") {

        if (this.aSinglePaymentReceived.tdNumber == "") {
          this.showErrorToast("Cheque Number is require");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber.length < 19) {
          this.showErrorToast("Card Number length must be 12");
          return;
        }
        if (this.aSinglePaymentReceived.holderName == 0) {
          this.showErrorToast("Holder name is require");
          return;
        }
        if (this.aSinglePaymentReceived.comment == 0) {
          this.showErrorToast("comment is require");
          return;
        }
        if (valueAmount == 0) {
          this.showErrorToast("Amount is require");
          return;
        }
        if (valueAmount < 0) {
          this.showErrorToast("Invalid Amount");
          return;
        }
        if(this.aSinglePaymentReceived.amount>this.limitAmount)
        {
          this.showErrorToast("Amount can not be greater then requested $" +this.limitAmount)
          return;
        }
      }
      if (what == "cash") {
        if (this.aSinglePaymentReceived.amount == 0) {
          this.showErrorToast("Amount is require");
          return;
        }
        if (valueAmount == 0) {
          this.showErrorToast("Amount is require");
          return;
        }
        if (valueAmount < 0) {
          this.showErrorToast("Invalid Amount");
          return;
        }
      } else if (what == "credit-card") {
        if (this.aSinglePaymentReceived.cardCVC == "") {
          this.showErrorToast("Card CVC is require");
          return;
        }
        if (this.aSinglePaymentReceived.cardCVC.length < 3) {
          this.showErrorToast("Card CVC must be of 3 length");
          return;
        }
        if (this.aSinglePaymentReceived.comment == "") {
          this.showErrorToast("Comment is require");
          return;
        }
        if (this.aSinglePaymentReceived.zip == "") {
          this.showErrorToast("Zip is require");
          return;
        }
        if (this.aSinglePaymentReceived.cardCVC.length < 3) {
          this.showErrorToast("Zip must be of 3 length");
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber == "") {
          this.showErrorToast("Card Number is require");
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber.length < 19) {
          this.showErrorToast("Card Number length must be 16");
          return;
        }
        if (this.aSinglePaymentReceived.holderName == "") {
          this.ShowWarning("Holder Name is require");
          return;
        }
        if (valueAmount < 0) {
          this.showErrorToast("Invalid Amount");
          return;
        }
      }
      this.aSinglePaymentReceived.paymentMethod = what;
      this.aSinglePaymentReceived.visitId = this.aSinglePatient.visitId;
      this.aSinglePaymentReceived.patientId = this.aSinglePatient.patientId;
      this.aSinglePaymentReceived.pndx = this.ActivePaymentRequest.pndx;

      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Trackers/SavPayRec";
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
    
      const myData = { dc: this.dummyComm, pr: this.aSinglePaymentReceived };
      this.btnProColl = true;
      this.axiosGetData(url, myData, 12);
    },
    collectPaymentOptionsClick(what) {
      // this.intDummyComm();
      // const url = this.SERVER + "/VNSPRAAPI/Trackers/GetPayRecDat";
      // this.dummyComm.extras = this.mixinMakeCommString(
      //   this.aSinglePatient.visitId,
      //   what
      // ); //pat.visitId;
      // const myData = this.dummyComm;
      //this.axiosGetData(url, myData, 11);
      if (what == "credit-card") $("#debit").modal("show");
      else if (what == "cash") $("#cash").modal("show");
      else if (what == "cheque") $("#cheque").modal("show");
    },
    collectPayment(rp) {
      if (rp.status == "Paid") {
        this.ShowErrorAutoClose("Payment already made.");
        return;
      }
      this.aSinglePaymentReceived = {
        pndx: 0,
        patientId: 0,
        practiceId: 0,
        visitId: rp.visitId,
        billNo: 0,
        collectedBy: 0,
        paymentDate: new Date(),
        amount: rp.amount,
        paymentMethod: "",
        holderName: "",
        tdNumber: "",
        cardCVC: "",
        comment: "",
        zip: "",
      };
      // console.log(rp);
      // //this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      // this.aSinglePaymentReceived=JSON.parse(JSON.stringify(rp));
      // //this.aSinglePaymentReceived.amount=rp.amount;
      // console.log("Point--> ",this.aSinglePaymentReceived);
      $("#paymentMethodv2").modal("show");
    },
    requestPaymentClick() {
      this.intDummyComm();
      this.dummyComm.extras = this.aSinglePatient.patientId;
      const url = this.SERVER + "/VNSPRAAPI/Patient/GetPayRequestPatient";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 18);
    },
    calcMainButtonClass(pat) {
      let xx = "btn btn-danger";
      if (pat.patientId > 0) {
        if (pat.isNew > 0) xx = "btn btn-warning";
        else xx = "btn btn-success";
      }
      return xx;
    },
    datePicker() {
      const self = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function(start, end) {
          self.startDate = new Date(start);
          self.endDate = new Date(end);
          self.initDate_1 =
            self.dateToMDY(self.startDate) +
            " - " +
            self.dateToMDY(self.endDate);
        }
      );
    },
    datePicker_1() {
      const self = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function(start, end) {
          self.startDate_1 = new Date(start);
          self.endDate_1 = new Date(end);
          self.initDate =
            self.dateToMDY(self.startDate_1) +
            " - " +
            self.dateToMDY(self.endDate_1);
        }
      );
    },
    datePicker_2() {
      const self = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function(start, end) {
          self.startDate_2 = new Date(start);
          self.endDate_2 = new Date(end);
          self.initDate_2 =
            self.dateToMDY(self.startDate_2) +
            " - " +
            self.dateToMDY(self.endDate_2);
        }
      );
    },
    GetAuditLog() {
      this.intDummyComm();
      this.dummyComm.myDate = "";
      //this.dummyComm.Extras = "";
      const url = this.SERVER + "/VNSPRAAPI/actionlog/GetInitData2";
      this.axiosGetData(url, this.dummyComm, 21);
    },
    saveInsuranceClick() {
      this.intDummyComm();
      let obj = {
        pndx: 0,
        patientId: 0,
        primaryInsurance: "",
        primaryInsuranceNo: "",
        primaryInsuranceGroupId: "",
        primaryInsuranceId: "",
        secondaryInsurance: "",
        secondaryInsuranceNo: "",
        secondaryInsuranceGroupId: "",
        secondaryInsuranceId: "",
        primaryFilePath: "",
        secondaryFilePath: "",
      };
      //var firstfile = $("#customFileLang_f").val();
      var FirstFileName = $("#customFileLang_fl").html();
      // var secondfile = $("#customFileLang_s").val();
      var SecondFileName = $("#customFileLang_sl").html();

      obj = this.insurance;
      obj.fndx = this.aSinglePatient.pndx;
      obj.patientId = this.aSinglePatient.patientId;
      obj.primaryInsuranceId = FirstFileName;
      obj.secondaryInsuranceId = SecondFileName;
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      obj.patientId = this.aSinglePatient.patientId;
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Patient/SavePatientInsurance";
      const myData = {
        dc: this.dummyComm,
        patientInsuranceInfo: obj,
      };
      this.axiosGetData(url, myData, 17);
    },
    getPatientInfo(pat) {
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      var date = moment(String(this.aSinglePatient.dosdate)).format(
        "YYYY-MM-DD"
      );
      this.aSinglePatient.dob = date;
      this.intDummyComm();
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId +
        this.UKEY +
        this.aSinglePatient.visitId +
        this.UKEY +
        this.aSinglePatient.patientId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      let url = this.SERVER + "/VNSPRAAPI/Patient/GetSnglPatAllData";
      let myData = this.dummyComm;
      this.axiosGetData(url, myData, 14);
    },
    showProfilePopup(pat, what) {
      //for Date
      this.endDate = new Date();
      this.startDate = new Date();
      this.startDate.setDate(this.startDate.getDate() - 365);
      this.initDate_1 =
        this.dateToMDY(this.startDate) + " - " + this.dateToMDY(this.endDate);
      this.endDate_1 = new Date();
      this.startDate_1 = new Date();
      this.startDate_1.setDate(this.startDate_1.getDate() - 365);
      this.initDate =
        this.dateToMDY(this.startDate_1) +
        " - " +
        this.dateToMDY(this.endDate_1);
      this.endDate_2 = new Date();
      this.startDate_2 = new Date();
      this.startDate_2.setDate(this.startDate_2.getDate() - 365);
      this.initDate_2 =
        this.dateToMDY(this.startDate_2) +
        " - " +
        this.dateToMDY(this.endDate_2);

     //debugger
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      //date changes
      if (this.aSinglePatient.dosLocalTime != "") {
        this.val1 = this.aSinglePatient.dosLocalTime.split("-")[1];
        if (this.val1.length == 1) {
          this.val1 = "0" + this.val1;
        }
        this.val2 = this.aSinglePatient.dosLocalTime.split("T");
        this.val2 = this.val2[0].split("-")[0].substring(2, 4);
      }
      this.modalDate = moment(String(this.aSinglePatient.dob)).format(
        "MM-DD-YYYY"
      );
      var date = moment(String(this.aSinglePatient.dosdate)).format(
        "YYYY-MM-DD"
      );
      this.aSinglePatient.dob = date;
      //   this.intDummyComm();
      //   let url = this.SERVER + "/VNSPRAAPI/Trackers/GetEmailTemps";
      //   let myData = this.dummyComm;
      //   this.axiosGetData(url, myData, 15);
      $("#details_home").click();
      this.intDummyComm();
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId +
        this.UKEY +
        this.aSinglePatient.visitId +
        this.UKEY +
        this.aSinglePatient.patientId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.patientIdProps = this.aSinglePatient.patientId;
      let url = this.SERVER + "/VNSPRAAPI/Patient/GetSnglPatAllData";
      let myData = this.dummyComm;
      this.axiosGetData(url, myData, 14);
      //alert(this.aSinglePatient);
      if (what == "text") $("#textHistory1221").click();
      else if (what == "email") $("#emailtHistory1221").click();
      //$("#newptModal").modal("show");
    },
    //payment request list filter
    searchMainList_1() {
      if (this.startDate != "" && this.endDate != "") {
        this.allFilterPatients_1 = this.requestPaymentsList.filter(
          (f) =>
            +new Date(f.dos) >= +new Date(this.startDate) &&
            +new Date(f.dos) <= +new Date(this.endDate)
        );
      }
    },
    //visit request list filter
    searchMainList_2() {
      if (this.startDate_1 != "" && this.endDate_1 != "") {
        this.allFilterVisitHist = this.visitHistory.filter(
          (f) =>
            +new Date(f.dosLocalTime) >= +new Date(this.startDate_1) &&
            +new Date(f.dosLocalTime) <= +new Date(this.endDate_1)
        );
      }
    },
    searchMainList_3() {
      if (this.startDate_2 != "" && this.endDate_2 != "") {
        this.allFilterPayHist = this.paymentHistory.filter(
          (f) =>
            +new Date(f.dos) >= +new Date(this.startDate_2) &&
            +new Date(f.dos) <= +new Date(this.endDate_2)
        );
      }
    },
    searchMainList() {
      if (this.mainSearch.searchExternalId !== null) {
        this.allFilterPatients = this.allRawPatients.filter((f) =>
          (f.externalId + " ").includes(this.mainSearch.searchExternalId)
        );
      } else {
        this.allFilterPatients = this.allRawPatients.filter(
          (f) =>
            f.firstName
              .toLowerCase()
              .startsWith(
                this.mainSearch.searchFirstName.toLowerCase().trim()
              ) &&
            f.lastName
              .toLowerCase()
              .startsWith(
                this.mainSearch.searchLastName.toLowerCase().trim()
              ) &&
            f.phone
              .toLowerCase()
              .startsWith(this.mainSearch.searchPhone.toLowerCase().trim())
        );
      }
      if (this.mainSearch.searchDate !== "") {
        const dd = new Date(this.mainSearch.searchDate);
        this.allFilterPatients = this.allFilterPatients.filter(
          (f) => f.dob == dd.toLocaleDateString()
        );
      }
    },
    getIcon(id) {
      //console.log(id);
      if (id == 100) return "assets/images/actions/comment.png";
      else if (id == 50) return "assets/images/actions/edit.png";
      else if (id == 51) return "assets/images/actions/sent.png";
      else if (id == 300) return "assets/images/actions/credit-card.png";
      else if (id == 302) return "assets/images/actions/stethoscope.png";
      else if (id == 303) return "assets/images/actions/stethoscope.png";
      else if (id == 201) return "assets/images/actions/mapping.png";
      else if (id == 301) return "assets/images/actions/cash-money.png";
      else if (id == 400) return "assets/images/actions/steps1.png";
      else if (id == 304) return "assets/images/actions/patient.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
    },
    dropDownButtonClick(pat) {
     //debugger
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId +
        this.UKEY +
        this.aSinglePatient.visitId +
        this.UKEY +
        this.aSinglePatient.patientId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      let url = this.SERVER + "/VNSPRAAPI/Patient/GetSinglePatientData";
      let myData = this.dummyComm;
      this.axiosGetData(url, myData, 22);
    },

    loadInit() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.filter = "";

      const myData = {
        dc: this.dummyComm,
        filter: this.$store.state.filterSTGDSP,
        sortColumn: this.sortColumn,
        sortColumnOption: this.sortColumnOption,
      };

      const url = this.SERVER + "/VNSPRAAPI/Patient/GetAllPatients";
      this.axiosGetData(url, myData, 1);
      this.StartLogoutTime();
    },

    //code for Data-Tables_
    pageChange(obj) {
     
      if (obj == "Next") {
        if (this.pageNumber < this.totalPages) {
          this.pageNumber += 1;
        }
      } else if (obj == "Previous" && this.pageNumber != 1) {
        this.pageNumber -= 1;
      } else {
        this.pageNumber = obj;
      }
      //show pagination
      if((this.showPagesMax/2) < (this.pageNumber))
      {
        this.showPagesMin = this.pageNumber-4;
        this.showPagesMax = this.pageNumber+4;
      }
      else if((this.showPagesMin/2)<(this.pageNumber))
      {
        this.showPagesMin = this.pageNumber-4;
        this.showPagesMax = this.pageNumber+4 ;
        if(this.showPagesMax<5)
        {
          this.showPagesMax = 5;
        }
      }
      else{
        this.showPagesMin = 1;
        this.showPagesMax = 5 ;
      }
       //show pagination
      this.loadInit();
    },

    orderBy(column) {
     //debugger
      // sortColumn:0,
      //     sortColumnOption:0,
      if (this.sortColumn == column) {
        switch (this.sortColumnOption) {
          case 0:
            this.sortColumnOption = 1;
            break;
          case 1:
            this.sortColumnOption = 2;
            break;
          case 2:
            this.sortColumn = 0;
            this.sortColumnOption = 0;
            break;
        }
      } else {
        this.sortColumn = column;
        this.sortColumnOption = 1;
      }
      this.pageNumber = 1;
      this.loadInit();
    },

    orderByRemeber(column) {
      this.orderByCol = column;
      if (column == 1) {
        if (this.asc_desc == "asc") {
          this.allFilterPatients = this.allFilterPatients.sort((a, b) =>
            a.firstName < b.firstName ? 1 : b.firstName < a.firstName ? -1 : 0
          );
        } else {
          this.allFilterPatients = this.allFilterPatients.sort((a, b) =>
            a.lastName > b.lastName ? 1 : b.lastName > a.lastName ? -1 : 0
          );
        }
      }
      if (column == 2) {
        if (this.asc_desc == "asc") {
          this.allFilterPatients = this.allFilterPatients.sort((a, b) =>
            a.patientId < b.patientId ? 1 : b.patientId < a.patientId ? -1 : 0
          );
        } else {
          this.allFilterPatients = this.allFilterPatients.sort((a, b) =>
            a.patientId > b.patientId ? 1 : b.patientId > a.patientId ? -1 : 0
          );
        }
      }
      if (column == 3) {
        if (this.asc_desc == "asc") {
          this.allFilterPatients = this.allFilterPatients.sort((a, b) =>
            a.externalId < b.externalId
              ? 1
              : b.externalId < a.externalId
              ? -1
              : 0
          );
        } else {
          this.allFilterPatients = this.allFilterPatients.sort((a, b) =>
            a.externalId > b.externalId
              ? 1
              : b.externalId > a.externalId
              ? -1
              : 0
          );
        }
      }
      if (column == 4) {
        if (this.asc_desc == "asc") {
          this.allFilterPatients = this.allFilterPatients.sort((a, b) =>
            a.ssn < b.ssn ? 1 : b.ssn < a.ssn ? -1 : 0
          );
        } else {
          this.allFilterPatients = this.allFilterPatients.sort((a, b) =>
            a.ssn > b.ssn ? 1 : b.ssn > a.ssn ? -1 : 0
          );
        }
      }
      if (column == 5) {
        if (this.asc_desc == "asc") {
          this.allFilterPatients = this.allFilterPatients.sort((a, b) =>
            a.dob < b.dob ? 1 : b.dob < a.dob ? -1 : 0
          );
        } else {
          this.allFilterPatients = this.allFilterPatients.sort((a, b) =>
            a.dob > b.dob ? 1 : b.dob > a.dob ? -1 : 0
          );
        }
      }
      if (column == 6) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.allFilterPatients = this.allFilterPatients.sort((a, b) =>
            a.gender < b.gender ? 1 : b.gender < a.gender ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.allFilterPatients = this.allFilterPatients.sort((a, b) =>
            a.gender > b.gender ? 1 : b.gender > a.gender ? -1 : 0
          );
        }
      }
      if (column == 7) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.allFilterPatients = this.allFilterPatients.sort((a, b) =>
            a.email < b.email ? 1 : b.email < a.email ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.allFilterPatients = this.allFilterPatients.sort((a, b) =>
            a.email > b.email ? 1 : b.email > a.email ? -1 : 0
          );
        }
      }
      if (column == 8) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.allFilterPatients = this.allFilterPatients.sort((a, b) =>
            a.phone < b.phone ? 1 : b.phone < a.phone ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.allFilterPatients = this.allFilterPatients.sort((a, b) =>
            a.phone > b.phone ? 1 : b.phone > a.phone ? -1 : 0
          );
        }
      }
    },
    //============================================================================
    async axiosGetData(myUrl, myData, what) {
      if (what != 22) {
        var loader = this.$loading.show({
          // Optional parameters
          color: "#03a9f3",
        });
      }
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          // if everything goes well -- we will get data
          if (what === 1) {
            loader.hide();
            if (res.data.dc.auditFlag === 1) {
             //debugger
              this.allRawPatients = res.data.allPatients;
              this.totalRows = res.data.dc.totalRow;
              this.totalPages = res.data.dc.totalPages;
              for (let i = 0; i < res.data.allPatients.length; i++) {
                if (this.allRawPatients[i].ptid !== null) {
                  this.allRawPatients[i].ptid = res.data.allPatients[
                    i
                  ].ptid.replace(/ /g, "");
                }
              }
            }
          } else if (what == 900) {
            loader.hide();
            this.successToastUpd();
            this.filteredPaymentRequests = res.data.list;
          } else if (what === 4) {
            loader.hide();
            this.totalRowsSuggest = res.data.dc.totalRow;
            this.totalPagesSuggest = res.data.dc.totalPages;
            this.VisitPayCounts = res.data.stats;
            this.allPatients = res.data.patient;
           //debugger // eslint-disable-line no-debugger
            for (let i = 0; i < res.data.patient.length; i++) {
              this.allPatients[i] = res.data.patient[i];
              this.allPatients[i].date1 = this.allPatients[i].dos.split("T")[0];
              this.allPatients[i].date2 = this.allPatients[i].date1
                .split("-")[0]
                .substring(2, 4);
              this.allPatients[i].date1 = this.allPatients[i].date1.split(
                "-"
              )[1];
              if (this.allPatients[i].date1.length == 1) {
                this.allPatients[i].date1 = "0" + this.allPatients[i].date1;
              }
            }
            this.allInsurances = res.data.insurance;
            for (let i = 0; i < this.allPatients.length; i++) {
              const dd = new Date(this.allPatients[i].dob);
              this.allPatients[i].dob = dd.toLocaleDateString();
            }
            //dos
            console.log(this.aSinglePatient);
            const obj = this.aSinglePatient;
            this.suggestedPatients = this.allPatients.filter(
              (f) =>
                f.firstName == obj.firstName ||
                f.lastName == obj.lastName ||
                f.ssn == obj.ssn ||
                f.phone == obj.phone ||
                f.email == obj.email
            );
            for (var i = 0; i < this.suggestedPatients.length; i++) {
              if (this.suggestedPatients[i].ptid !== null) {
                this.suggestedPatients[i].ptid = this.suggestedPatients[
                  i
                ].ptid.replace(/ /g, "");
              }
            }
            $("#mergeModal").modal("show");
          } else if (what === 12) {
           //debugger
          loader.hide(); 
          this.successToastUpd();
          this.aSinglePaymentReceived.tdNumber = "";
          this.aSinglePaymentReceived.holderName = "";
          this.aSinglePaymentReceived.cardCVC = "";
          this.aSinglePaymentReceived.ExpirationDate = "";
          this.aSinglePaymentReceived.comment = "";
          this.aSinglePaymentReceived.zip = "";
          this.aSinglePaymentReceived.amount="";
            for(let k=0;k<res.data.list.length;k++){
            //dos
            res.data.list[k].dos = res.data.list[k].dos.split("T");
            res.data.list[k].dos = res.data.list[k].dos[0];
            //dare req
            res.data.list[k].billDate = res.data.list[k].billDate.split("T");
            res.data.list[k].billDate = res.data.list[k].billDate[0];
          }  
          this.filteredPaymentRequests = res.data.list;
          this.totalRowsPays = res.data.dc.totalRow;
          this.totalPagesPays = res.data.dc.totalPages;
          this.btnProColl = false;
          $("#cash").modal("hide");
          $("#debit").modal("hide");
          $("#cheque").modal("hide");
       } else if (what == 9000){
             loader.hide();
             if(res.data.auditFlag == 1){
             this.successToastUpd("Reminder sent successfully.");
             } else{ this.errorToastUpd(res.data.auditFlagVal); }
             $("#reminder").modal("hide");
       } else if(what == 9001){
             loader.hide();
             this.successToastUpd("Deleted successfully.");
             this.getPaymentResTabl();
       } else if (what == 9002){
             loader.hide();
             this.successToastUpd("Receipt sent successfully.");
             $("#displayReceipt").modal("hide");
       } else if (what == 9003){
             loader.hide();
             this.successToastUpd("Amount Refunded Successful!");
             for(let k=0;k<res.data.list.length;k++){
            //dos
            res.data.list[k].dos = res.data.list[k].dos.split("T");
            res.data.list[k].dos = res.data.list[k].dos[0];
            //dare req
            res.data.list[k].billDate = res.data.list[k].billDate.split("T");
            res.data.list[k].billDate = res.data.list[k].billDate[0];
          }  
          this.refundAmount = "";
          //this.filteredPaymentRequests = res.data.list;
          this.totalRowsPays = res.data.dc.totalRow;
          this.totalPagesPays = res.data.dc.totalPages;
          $("#displayReceipt11").modal("hide");
          this.getPaymentResTabl();
        } else if (what === 14) {
            loader.hide();
              this.$nextTick(()=>{$('#newptModal').on('shown.bs.modal', function (e) {
              console.log($(document).off('focusin.modal'));}
              )});
            if (res.data.dc.auditFlag === 1) {
              this.aSinglePatient = res.data.patient;
              this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(
                / /g,
                ""
              );
              this.insurance = res.data.insurances;
              this.visitQuests = res.data.quests.quests;
              this.visitDemo = res.data.quests.quests;
              this.requestPaymentsList = res.data.lpr;
              this.paymentHistory = res.data.paymentHistory;
              //this.textHistory = res.data.textHistory;
              this.userTexts = res.data.userTexts;
              this.filterTextSearch = this.userTexts;
              this.emailHistory = res.data.emailHistory;
              this.VhpageNumber =  res.data.dc.pageNumber;
              this.VhpageSize = res.data.dc.pageSize;
              this.VhtotalPages = res.data.dc.totalPages;
              this.VhtotalRows =  res.data.dc.totalRow;
              this.visitHistory = res.data.visitHistory;
              var date = moment(String(this.aSinglePatient.dob)).format(
                "YYYY-MM-DD"
              );
              this.aSinglePatient.dob = date;
              if (res.data.insurances != null) {
                this.insurance = res.data.insurances;
                if (this.insurance.secondaryInsuranceId == "")
                  this.insurance.secondaryInsuranceId = "Secondary Id";
                if (this.insurance.primaryInsuranceId == "")
                  this.insurance.primaryInsuranceId = "Insurance Id";
                console.log((this.insurance = res.data.insurances));
              }
              this.users = res.data.users;
              $("#newptModal").modal("show");
            } else {
              this.errorToastUpd(res.data.dc.auditFlagVal);
            }
            //  document.getElementById("customFileLang_f").value = "";
            //  document.getElementById("customFileLang_s").value = "";
            //  document.getElementById("customFileLang_sl").innerHTML = "Secondary Id";
          } else if (what === 22) {
           //debugger
            if (res.data.dc.auditFlag === 1) {
              //this.aSinglePatient = res.data.patient;
              this.visitQuests = res.data.quests.quests;
              this.visitDemo = res.data.quests.quests;
              this.requestPaymentsList = res.data.lpr;
              this.paymentHistory = res.data.paymentHistory;
              //this.textHistory = res.data.textHistory;
              this.emailHistory = res.data.emailHistory;
              this.visitHistory = res.data.visitHistory;
              var date1 = moment(String(this.aSinglePatient.dob)).format(
                "YYYY-MM-DD"
              );
              this.aSinglePatient.dob = date1;
              if (res.data.insurances != null) {
                this.aSinglePatient.insurance = res.data.insurances;
                if (this.aSinglePatient.insurance.secondaryInsuranceId == "")
                  this.aSinglePatient.insurance.secondaryInsuranceId =
                    "Secondary Id";
                if (this.aSinglePatient.insurance.primaryInsuranceId == "")
                  this.aSinglePatient.insurance.primaryInsuranceId =
                    "Insurance Id";
                console.log(
                  (this.aSinglePatient.insurance = res.data.insurances)
                );
              }
              this.users = res.data.users;
            } else {
              this.ShowError(res.data.dc.auditFlagVal);
            }
            // document.getElementById("customFileLang_f").value = "";
            // document.getElementById("customFileLang_s").value = "";
            // document.getElementById("customFileLang_sl").innerHTML =
            //   "Secondary Id";
          } else if (what == 7) {
            loader.hide();
            if (res.data.auditFlag == 1) {
              this.successToastUpd();
            } else {
              this.errorToastUpd(res.data.auditFlagVal);
            }
          } else if (what === 17) {
            this.successToastUpd("Insurance saved successfully.");
            loader.hide();
            // if (res.data.dc.auditFlag === 1) {
            //   this.successToastUpd("Insurance saved successfully.");
            //   //document.getElementById("customFileLang_f").value = "";
            //   //document.getElementById("customFileLang_s").value = "";
            //   //this.allRawPatients = res.data.patients;
            //   //this.stagesSteps = res.data.stageSteps;
            //   //this.stageRes = res.data.stageRes;
            //   //this.stepRes = res.data.stepRes;
            // } else {
            //   this.errorToastUpd(res.data.dc.auditFlag);
            // }
          } else if (what === 15) {
            loader.hide();
           //debugger
            this.emailTempsList = res.data;
            this.emailTempsList.splice(0, 0, {
              name: "Compose",
              emailTemplateId: 0,
              emailText: "",
            });
          } else if (what === 16) {
            // after saving patient information
            loader.hide();
           //debugger
            this.successToastUpd();
            if (res.data.dc.auditFlag === 1) {
              this.allRawPatients = res.data.allPatients;
              this.loadInit();
            }
          } else if (what === 18) {
            loader.hide();
            if (res.data.dc.auditFlag > 0) {
              if (res.data.lpr.length < -991) {
                this.ShowErrorAutoClose("No Payment Request was made.");
                return;
              }
              this.requestPaymentsList = res.data.lpr;
              // let xx = this.requestPaymentsList.find(
              //   (f) => f.visitId == this.aSinglePatient.visitId
              // );
              // console.log(xx);
              // if (typeof xx !== "undefined")
              //   this.aSingleRequestPayment = JSON.parse(JSON.stringify(xx));
              // else {
              //   this.aSingleRequestPayment = {
              //     billNo: 0,
              //     amount: 0,
              //     email: "",
              //     phone: "",
              //     comment: "",
              //   };
              // }
              // $("#paymentRequest").modal("show");
            }
          } else if (what == 8000){
            loader.hide();
            for(let k=0;k<res.data.list.length;k++){
            //dos
            res.data.list[k].dos = res.data.list[k].dos.split("T");
            res.data.list[k].dos = res.data.list[k].dos[0];
            //dare req
            res.data.list[k].billDate = res.data.list[k].billDate.split("T");
            res.data.list[k].billDate = res.data.list[k].billDate[0];
          }  
          this.filteredPaymentRequests = res.data.list;
          this.totalRowsPays = res.data.dc.totalRow;
          this.totalPagesPays = res.data.dc.totalPages;
        } else if (what === 19) {
            loader.hide();
            if (res.data.auditFlag > 0) {
              this.successToastUpd("Reminder Sent");
            } else {
              this.errorToastUpd(res.data.auditFlagVal);
            }
          } else if (what === 404) {
            loader.hide();
            this.totalRowsSuggest = res.data.dc.totalRow;
            this.totalPagesSuggest = res.data.dc.totalPages;
            this.VisitPayCounts = res.data.stats;
            this.allPatients = res.data.patient;
            this.allInsurances = res.data.insurance;
            for (let m = 0; m < this.allPatients.length; m++) {
              const dd = new Date(this.allPatients[m].dob);
              this.allPatients[m].dob = dd.toLocaleDateString();
              //this.allPatients[i].dobd = dd;
            }
            const obj = this.aSinglePatient;
            this.suggestedPatients = this.allPatients;
            // for (var l = 0; l < this.suggestedPatients.length; l++) {
            //   if (this.suggestedPatients[l].ptid !== null) {
            //     this.suggestedPatients[l].ptid = this.suggestedPatients[
            //       i
            //     ].ptid.replace(/ /g, "");
            //   }
            // }
          } else if (what === 400) {
            loader.hide();
            this.totalRowsSuggest = res.data.dc.totalRow;
            this.totalPagesSuggest = res.data.dc.totalPages;
            this.VisitPayCounts = res.data.stats;
            this.allPatients = res.data.patient;
            this.allInsurances = res.data.insurance;
            for (let k = 0; k < this.allPatients.length; k++) {
              const dd = new Date(this.allPatients[k].dob);
              this.allPatients[k].dob = dd.toLocaleDateString();
            }
            const obj = this.aSinglePatient;
            this.suggestedPatients = this.allPatients;
            for (let j = 0; j < this.suggestedPatients.length; j++) {
              if (this.suggestedPatients[j].ptid !== null) {
                this.suggestedPatients[j].ptid = this.suggestedPatients[
                  j
                ].ptid.replace(/ /g, "");
              }
            }
          }  else if (what === 500) {
            loader.hide();
            this.totalRowsSuggest1 = res.data.dc.totalRow;
            this.totalPagesSuggest1 = res.data.dc.totalPages;
            this.VisitPayCounts = res.data.stats;
            this.allPatients = res.data.patient;
            this.allInsurances = res.data.insurance;
            for (let k = 0; k < this.allPatients.length; k++) {
              const dd = new Date(this.allPatients[k].dob);
              this.allPatients[k].dob = dd.toLocaleDateString();
            }
            const obj = this.aSinglePatient;
            this.suggestedPatients1 = this.allPatients;
            for (let j = 0; j < this.suggestedPatients1.length; j++) {
              if (this.suggestedPatients1[j].ptid !== null) {
                this.suggestedPatients1[j].ptid = this.suggestedPatients1[
                  j
                ].ptid.replace(/ /g, "");
              }
            }
          } else if (what === 20) {
            loader.hide();
           //debugger // eslint-disable-line no-debugger
            if (res.data.auditFlag > 0) {
              this.getPatientInfo(this.aSinglePatient);
              this.successToastUpd("Email Sent");
            } else {
              this.ShowErrorAutoClose("Unable to Send Email");
            }
          } else if (what === 28) {
            loader.hide();
            this.smsTempsList = res.data;
            this.smsTempsList.splice(0, 0, {
              name: "Compose",
              smsTemplateId: 0,
              smsText: "",
            });
            $("#sendText").modal("show");
          }
          // else if (what === 26) {
          //  //debugger // eslint-disable-line no-debugger
          //   if (res.data.auditFlag>0){
          //     this.showProfilePopup(this.aSinglePatient,'');
          //     this.chatSms = "";
          //     this.successToastUpd("Text message sent");
          //     $("#sendText").modal("hide");
          //   }
          //   else
          //   {
          //     this.ShowErrorAutoClose("Unable to Send Email");
          //   }
          // }
          else if (what === 27) {
            loader.hide();
            if (res.data.auditFlag > 0) {
              this.successToastUpd("Text message sent");
              this.getPatientInfo(this.aSinglePatient);
              this.chatSms = "";
            } else {
              this.ShowErrorAutoClose("Unable to Send Email");
            }
          } else if (what === 24) {
            this.aSingleUserSmsHist = res.data;
            this.textHistorySerch = this.aSingleUserSmsHist;
            this.textHistory= [];
            for (let j = 0; j < this.textHistorySerch.length; j++) {
              this.textHistory.push(this.textHistorySerch[j]);
           }
            loader.hide();
            // if (res.data.length > 0) {
            //   this.textHistory = res.data;
            // } else {
            //   this.ShowErrorAutoClose("No data Exists");
            // }
          } else if (what === 25) {
            loader.hide();
            if (res.data.auditFlag > 0) {
              this.successToastUpd("Text message sent");
              $("#sendText").modal("hide");
            } else {
              this.ShowErrorAutoClose("Unable to Send Email");
            }
          } else if (what === 21) {
            loader.hide();
            this.auditData = res.data.visitHist;
          } else if (what === 23) {
            loader.hide();
            if (res.data.dc.auditFlag > 0) {
              this.successToastUpd();
              this.allRawPatients = res.data.patients;
              this.stagesSteps = res.data.stageSteps;
              //this.allInsurances = res.data.insurance;
              this.stepRes = res.data.stepRes;
              $("#mergeModal").modal("hide");
              $("#alertModal").modal("hide");
            } else this.errorToast(res.data.dc.auditFlagVal);
          } else if (what === 214) {
           //debugger
            this.successToastUpd();
            loader.hide();
            if (res.data.dc.auditFlag > 0) {
              // $("#home_2")
              //   .DataTable()
              //   .destroy();
              this.loadInit();
            } else this.errorToast(res.data.dc.auditFlagVal);
          } else if (what === 26) {
            loader.hide();
            if (res.data.dc.auditFlag > 0) {
              //this.allInsurances = res.data.insurance;
              //this.$router.go(0);
              //$("#mergeModal").modal("hide");
              $("#alertModal").modal("hide");
              this.successToastUpd();
            } else this.errorToast(res.data.dc.auditFlagVal);
          }
        })
        .catch(function(error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          } else {
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
        });
    }, // axiosGetData
    suggestedClick() {
      const obj = this.aSinglePatient;
      this.suggestedPatients = this.allPatients.filter(
        (f) =>
          f.firstName.toLowerCase() == obj.firstName.toLowerCase() ||
          f.lastName.toLowerCase() == obj.lastName.toLowerCase() ||
          f.ssn == obj.ssn ||
          f.phone == obj.phone ||
          f.email.toLowerCase() == obj.email.toLowerCase()
      );
    },

    loader_1() {
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
    },
    updateDetailsClick() {
      //For validation
      if (this.aSinglePatient.firstName == "") {
        this.ShowWarning("Firstname is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.lastName == "") {
        this.ShowWarning("Lastname is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.dob == "") {
        this.ShowWarning("Date of Birth is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.gender == "0") {
        this.ShowWarning("Gender is require");
        event.preventDefault();
        return;
      }
      if (!this.isValidateDate(this.aSinglePatient.dob)) {
        this.ShowWarning("Valid Date of Birth required");
        event.preventDefault();
        return;
      }
      if (this.aSinglePatient.email != null) {
        if (!this.validEmail(this.aSinglePatient.email)) {
          this.Validity(this.e);
        }
      }

     //debugger
     this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.filter = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
     
      const url = this.SERVER + "/VNSPRAAPI/Patient/SavePatientPortalBasicInfo";
        const myData = {
        dc: this.dummyComm,
        patient: this.aSinglePatient,
        filter: this.$store.state.filterSTGDSP,
        sortColumn: this.sortColumn,
        sortColumnOption: this.sortColumnOption,
      };

      this.axiosGetData(url, myData, 16);
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    filterSearchList_1() {
      this.filterTextSearch = this.userTexts.filter((f) =>
        f.name.toLowerCase().startsWith(this.TextSearch.toLowerCase())
      );
    },
    filterSearchList() {
      try {
       //debugger // eslint-disable-line no-debugger
        let dd = new Date(this.filterDate);
        let ds = dd.toLocaleDateString();
        if (dd == "Invalid Date" || dd.getFullYear() < 1900) {
          this.suggestedPatients = this.allPatients.filter(
            (f) =>
              f.firstName
                .toLowerCase()
                .startsWith(this.filterFirstName.toLowerCase()) &&
              f.lastName
                .toLowerCase()
                .startsWith(this.filterLastName.toLowerCase()) &&
              f.phone.startsWith(this.filterPhone)
          );
        } else {
          this.suggestedPatients = this.allPatients.filter(
            (f) =>
              f.firstName
                .toLowerCase()
                .startsWith(this.filterFirstName.toLowerCase()) &&
              f.lastName
                .toLowerCase()
                .startsWith(this.filterLastName.toLowerCase()) &&
              f.phone.startsWith(this.filterPhone) &&
              f.dob == ds
          );
        }
      } catch {
        this.suggestedPatients = this.allPatients.filter(
          (f) =>
            f.firstName
              .toLowerCase()
              .startsWith(this.filterFirstName.toLowerCase()) &&
            f.lastName
              .toLowerCase()
              .startsWith(this.filterLastName.toLowerCase()) &&
            f.phone.startsWith(this.filterPhone)
        );
      }
      //console.log(this.suggestedPatients);
    },
    allPatientsClick() {
      this.filterFirstName = "";
      this.filterLastName = "";
      this.filterPhone = "";
      this.filterDate = "";
      this.filterDDate = "";
      this.filterSearchList();
    },
    mergeContinueClick() {
      if (this.mergedPat.firstName == "") {
        this.ShowWarning("First Name is require");
        event.preventDefault();
        return;
      } else if (this.mergedPat.lastName == "") {
        this.ShowWarning("Last Name is require");
        event.preventDefault();
        return;
      } else if (this.mergedPat.gender == 0) {
        this.ShowWarning("Gender is require");
        event.preventDefault();
        return;
      } else if (!this.isValidateDate(this.mergedPat.dob)) {
        this.ShowWarning("Valid Date of Birth required");
        event.preventDefault();
        return;
      }
      Swal.fire({
        title: "Are you sure?",
        text:
          "After you merge these profiles. This action cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Merge",
      }).then((result) => {
        if (result.value) {
          const dd = new Date();
          this.intDummyComm();
         //debugger // eslint-disable-line no-debugger
          this.dummyComm.visitId = this.aSinglePatient.visitId;
          this.dummyComm.patientId = this.aSinglePatient.patientId;
          //**$$**
          this.aSinglePatient.firstName = this.mergedPat.firstName;
          this.aSinglePatient.lastName = this.mergedPat.lastName;
          this.aSinglePatient.dob = this.dateToSqlServerDateFormat(
            this.mergedPat.dob
          );
          this.aSinglePatient.gender = this.mergedPat.gender;
          this.aSinglePatient.phone = this.mergedPat.phone;
          this.aSinglePatient.email = this.mergedPat.email;
          this.aSinglePatient.ssn = this.mergedPat.ssn;
          this.aSinglePatient.address = this.mergedPat.address;
          this.aSinglePatient.city = this.mergedPat.city;
          this.aSinglePatient.state = this.mergedPat.state;
          this.aSinglePatient.zip = this.mergedPat.zip;
          this.aSinglePatient.externalId = this.mergedPat.externalId;
          this.insurance.primaryInsurance = this.mergedPat.primaryIns;
          this.insurance.primaryInsuranceNo = this.mergedPat.primaryInsNo;
          this.insurance.primaryInsuranceId = this.mergedPat.primaryInsId;
          this.insurance.primaryInsuranceGroupId = this.mergedPat.primaryInsGroupId;
          this.insurance.secondaryInsurance = this.mergedPat.secondIns;
          this.insurance.secondaryInsuranceNo = this.mergedPat.secondInsNo;
          this.insurance.secondaryInsuranceId = this.mergedPat.secondInsId;
          this.insurance.secondaryInsuranceGroupId = this.mergedPat.secondInsGroupId;
          //**$$**
          this.dummyComm.extras =
            this.aSelectedPatient.patientId +
            this.UKEY +
            dd.toLocaleDateString() +
            " " +
            dd.toLocaleTimeString();
           const url = this.SERVER + "/VNSPRAAPI/Trackers/MerPat1";
          const myData = {
            dc: this.dummyComm,
            pat: this.aSinglePatient,
            ins: this.insurance,
          };
          this.axiosGetData(url, myData, 26);
        }
      });
    },
  mergeModalClick1() {
   //debugger
      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.pageNumber = this.pageNumberSuggest;
      this.dummyComm.pageSize = this.pageSizeSuggest;
      this.dummyComm.filter = "";

      //+++555+++/
      let startDate = "";
      let endDate = "";

      startDate = new Date(1805, 1, 1);
      endDate = new Date();

      const filter = {
        veinsId: this.suggested.searchVeinsId,
        externalId: this.suggested.searchExternalId,
        firstName: this.suggested.searchFirstName,
        lastName: this.suggested.searchLastName,
        phone: this.suggested.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        Dob: this.suggested.Dob,
        stageId: 0,
      };

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sortColumn: this.sortColumnSuggest,
        sortColumnOption: this.sortColumnOptionSuggest,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetAllPatsPageSuggest";
      this.axiosGetData(url, myData, 404);
    },
    mergeModalClick(pat) {
     //debugger
       $("#mappingClick").click()
      if(typeof pat !== "undefined"){
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      if (this.aSinglePatient.ptid !== null) {
        this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g, "");
      }
      // this.val11 = this.aSinglePatient.dosdate.split("/")[0];
      // if (this.val11.length == 1) {
      //   this.val11 = "0" + this.val11;
      // }
      // this.val22 = this.aSinglePatient.dosdate.split("/")[2].substring(2, 4);
      }

      this.intDummyComm();
      this.dummyComm.extras = "nFilter";
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.pageNumber = this.pageNumberSuggest;
      this.dummyComm.pageSize = this.pageSizeSuggest;
      this.dummyComm.filter = "";

      //+++555+++/
      let startDate = "";
      let endDate = "";

      startDate = new Date(1805, 1, 1);
      endDate = new Date();

      const filter = {
        veinsId: this.suggested.searchVeinsId,
        externalId: "",
        firstName: this.aSinglePatient.firstName,
        lastName: this.aSinglePatient.lastName,
        phone: this.aSinglePatient.phone,
        email: this.aSinglePatient.email,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        Dob: this.dateToYMD(this.aSinglePatient.dob),
        stageId: 0,
      };

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sortColumn: this.sortColumnSuggest,
        sortColumnOption: this.sortColumnOptionSuggest,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetAllPatsPageSuggest";
      this.axiosGetData(url, myData, 4);
    },

    alertModalClick_Suggested(pat) {
      this.aSelectedPatient = JSON.parse(JSON.stringify(pat));
      //remove space ptId
      this.aSelectedPatient.ptid = this.aSelectedPatient.ptid.replace(/ /g, "");
      //remove spaces
      if (this.aSinglePatient.ptid !== null) {
        this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g, "");
      }

      const obj = this.allInsurances.filter(
        (f) => f.patientId == this.aSelectedPatient.patientId
      );
      const obj1 = this.VisitPayCounts.filter(
        (f) => f.patientId == this.aSelectedPatient.patientId
      );
      //console.log(obj);
      this.aSelectedInsurance = {
        primaryInsurance: "",
        primaryInsuranceNo: "",
        primaryInsuranceId: "",
        primaryInsuranceGroupId: "",
        secondaryInsurance: "",
        secondaryInsuranceNo: "",
        secondaryInsuranceId: "",
        secondaryInsuranceGroupId: "",
      };

      this.aSelectedCounts = {
        VisitCounts: 0,
        PaymentCounts: 0,
        EmailCounts: 0,
        TextCounts: 0,
      };
      if (obj.length > 0) {
        for (let i = 0; i < obj.length; i++) {
          if (obj[i].isPrimary == 1) {
            this.aSelectedInsurance.primaryInsurance = obj[i].insuranceName;
            this.aSelectedInsurance.primaryInsuranceNo = obj[i].insuranceNo;
            this.aSelectedInsurance.primaryInsuranceId = obj[i].insuranceId;
            this.aSelectedInsurance.primaryInsuranceGroupId =
              obj[i].insuranceGroupId;
          } else {
            this.aSelectedInsurance.secondaryInsurance = obj[i].insuranceName;
            this.aSelectedInsurance.secondaryInsuranceNo = obj[i].insuranceNo;
            this.aSelectedInsurance.secondaryInsuranceId = obj[i].insuranceId;
            this.aSelectedInsurance.secondaryInsuranceGroupId =
              obj[i].insuranceGroupId;
          }
        }
      }
      if (obj1.length > 0) {
        for (let j = 0; j < obj1.length; j++) {
          this.aSelectedCounts.VisitCounts = obj1[j].visits;
          this.aSelectedCounts.PaymentCounts = obj1[j].payments;
          this.aSelectedCounts.EmailCounts = obj1[j].emails;
          this.aSelectedCounts.TextCounts = obj1[j].texts;
        }
      }
      // for insurance
      this.insurance.primaryInsurance = this.aSinglePatient.insurance.primaryInsurance;
      this.insurance.primaryInsuranceNo = this.aSinglePatient.insurance.primaryInsuranceNo;
      this.insurance.primaryInsuranceId = this.aSinglePatient.insurance.primaryInsuranceId;
      this.insurance.primaryInsuranceGroupId = this.aSinglePatient.insurance.primaryInsuranceGroupId;
      this.insurance.secondaryInsurance = this.aSinglePatient.insurance.secondaryInsurance;
      this.insurance.secondaryInsuranceNo = this.aSinglePatient.insurance.secondaryInsuranceNo;
      this.insurance.secondaryInsuranceId = this.aSinglePatient.insurance.secondaryInsuranceId;
      this.insurance.secondaryInsuranceGroupId = this.aSinglePatient.insurance.secondaryInsuranceGroupId;
      // *$$*
      const arr = this.aSinglePatient.doBstr.split("/");
      const dd = new Date(arr[2], arr[0] - 1, arr[1]);
      if (this.aSinglePatient.phone == "") {
        this.phone = this.aSelectedPatient.phone;
      } else {
        this.phone = this.aSinglePatient.phone;
      }
      if (this.aSinglePatient.email == "") {
        this.email = this.aSelectedPatient.email;
      } else {
        this.email = this.aSinglePatient.email;
      }
      if (this.aSinglePatient.ssn == "") {
        this.ssn = this.aSelectedPatient.ssn;
      } else {
        this.ssn = this.aSinglePatient.ssn;
      }
      if (this.aSinglePatient.streetAddress == "") {
        this.address = this.aSelectedPatient.address;
      } else {
        this.address = this.aSinglePatient.streetAddress;
      }
      if (this.aSinglePatient.city == "") {
        this.city = this.aSelectedPatient.city;
      } else {
        this.city = this.aSinglePatient.city;
      }
      if (this.aSinglePatient.state == "") {
        this.state = this.aSelectedPatient.state;
      } else {
        this.state = this.aSinglePatient.state;
      }
      if (this.aSinglePatient.zip == "") {
        this.zip = this.aSelectedPatient.zip;
      } else {
        this.zip = this.aSinglePatient.zip;
      }
      if (this.insurance.primaryInsurance == "") {
        this.primaryInsurance = this.aSelectedInsurance.primaryInsurance;
      } else {
        this.primaryInsurance = this.insurance.primaryInsurance;
      }
      if (this.insurance.primaryInsuranceNo == "") {
        this.primaryInsurance = this.aSelectedInsurance.primaryInsuranceNo;
      } else {
        this.primaryInsuranceNo = this.insurance.primaryInsuranceNo;
      }
      if (this.insurance.primaryInsuranceId == "") {
        this.primaryInsuranceId = this.aSelectedInsurance.primaryInsuranceId;
      } else {
        this.primaryInsuranceId = this.insurance.primaryInsurance;
      }
      if (this.insurance.primaryInsGroupId == "") {
        this.primaryInsGroupId = this.aSelectedInsurance.primaryInsGroupId;
      } else {
        this.primaryInsGroupId = this.insurance.primaryInsGroupId;
      }
      if (this.insurance.secondaryInsurance == "") {
        this.secondaryInsurance = this.aSelectedInsurance.secondaryInsurance;
      } else {
        this.secondaryInsurance = this.insurance.secondaryInsurance;
      }
      if (this.insurance.secondaryInsuranceNo == "") {
        this.secondaryInsuranceNo = this.aSelectedInsurance.secondaryInsuranceNo;
      } else {
        this.secondaryInsuranceNo = this.insurance.secondaryInsuranceNo;
      }
      if (this.insurance.secondaryInsuranceId == "") {
        this.secondaryInsuranceId = this.aSelectedInsurance.secondaryInsuranceId;
      } else {
        this.secondaryInsuranceId = this.insurance.secondaryInsuranceId;
      }
      if (this.insurance.secondaryInsuranceGroupId == "") {
        this.secondaryInsuranceGroupId = this.aSelectedInsurance.secondaryInsuranceGroupId;
      } else {
        this.secondaryInsuranceGroupId = this.insurance.secondaryInsuranceGroupId;
      }
      this.mergedPat = {
        firstName: this.aSelectedPatient.firstName,
        lastName: this.aSelectedPatient.lastName,
        dob: this.dateToYMD(dd),
        gender: this.aSelectedPatient.gender,
        phone: this.phone,
        email: this.email,
        ssn: this.ssn,
        address: this.address,
        city: this.city,
        state: this.state,
        zip: this.zip,
        primaryIns: this.primaryInsurance,
        primaryInsNo: this.primaryInsuranceNo,
        primaryInsId: this.primaryInsuranceId,
        primaryInsGroupId: this.primaryInsuranceGroupId,
        secondIns: this.secondaryInsurance,
        secondInsNo: this.secondaryInsuranceNo,
        secondInsId: this.secondaryInsuranceId,
        secondInsGroupId: this.secondaryInsuranceGroupId,
      };
      // *$$*
      $("#alertModal").modal("show");
    },
    paymentReminderClick() {
      if (this.aSinglePatient.phone.length == 0) {
        this.ShowWarning("Enter Phone number");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.phone.length < 12) {
        this.ShowWarning("Phone number length must be 10");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.email.length == 0) {
        this.ShowWarning("Enter Email");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.email.length > 0) {
        if (this.aSinglePatient.email != null) {
          if (!this.validEmail(this.aSinglePatient.email)) {
            this.Validity(this.e);
          }
        }
      }
      this.aSinglePatient;
      this.aSingleRequestPayment;
      const Reminder = {
        patientId: this.aSingleRequestPayment.patientId,
        pndx: this.aSingleRequestPayment.pndx,
        firstName: this.aSinglePatient.firstName,
        lastName: this.aSinglePatient.lastName,
        status: this.allFilterPatients_1[0].inputStatus,
        amount: this.aSingleRequestPayment.amount,
        phoneNo: this.aSinglePatient.phone,
        email: this.aSinglePatient.email,
        dummy: this.dummyComm.extras,
      };
      const url = this.SERVER + "/VNSPRAAPI/Patient/ReminderEmailSms";
      const myData = {
        Reminder: Reminder,
        dc: this.dummyComm,
      };
      this.axiosGetData(url, myData, 19);
    },
    GetPaymentInfo(rp) {
      this.aSingleRequestPayment = rp;
    },
    sendEmailClick() {
      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetEmailTemps";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 15);
    },
    selectedEmailTempClass(email) {
      if (email.emailTemplateId === 0)
        return "list-group-item list-group-item-action btn-success";
      else {
        if (this.aSingleEmail.emailTemplateId == email.emailTemplateId)
          return "list-group-item list-group-item-action active show";
        else return "list-group-item list-group-item-action show";
      }
    },
    emailTempsListClick(email) {
      this.aSingleEmail.emailTemplateId = email.emailTemplateId;
      if (email.emailTemplateId > 0)
        this.aSingleEmail = JSON.parse(JSON.stringify(email));
      else
        this.aSingleEmail = {
          name: "",
          emailTemplateId: 0,
          emailSubject: "",
          email: "",
          emailText: "",
        };
    },

    selectedEmailTempIcon(email) {
      if (email.emailTemplateId == 0) return "fas fa-envelope mr-3";
      else return "far fa-file-alt mr-3";
    },
    sendTextModalClose() {
      $("#sendText").modal("hide");
    },
    sendEmail() {
      if (this.aSingleEmail.name == "") {
        this.ShowWarning("Name is require");
        event.preventDefault();
        return;
      }
      if (this.aSinglePatient.email == "") {
        this.ShowWarning("Email is require");
        event.preventDefault();
        return;
      }
      if (this.aSingleEmail.emailText == "") {
        this.ShowWarning("Text is require");
        event.preventDefault();
        return;
      }
      if (this.aSingleEmail.emailSubject == "") {
        this.ShowWarning("Subject is require");
        event.preventDefault();
        return;
      }
      if (this.aSinglePatient.email != null) {
        if (!this.validEmail(this.aSinglePatient.email)) {
          this.Validity(this.e);
        }
      }
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Patient/SendEmail";

      const EmailData = {
        SentTo: this.aSinglePatient.email,
        SentFrom: "",
        Password: "",
        Body: this.aSingleEmail.emailText,
        Subject: this.aSingleEmail.emailSubject,
        TemplateName: this.aSingleEmail.name,
        UserId: this.dummyComm.ownerId,
        OwnerId: this.dummyComm.ownerId,
        PracticeId: this.dummyComm.practiceId,
        PatientId: this.aSinglePatient.patientId,
        VisitId: this.aSinglePatient.visitId,
        SentLocal: new Date(),
        //SentServer:
      };
      const myObject = {
        dc: this.dummyComm,
        email: EmailData,
      };
      this.axiosGetData(url, myObject, 20);
    },

    sendTextClick() {
      if (this.smsTempsList.length <= 0) {
        this.intDummyComm();
        const url = this.SERVER + "/VNSPRAAPI/Trackers/GetTxtTem";
        const myData = this.dummyComm;
        this.axiosGetData(url, myData, 28);
      } else $("#sendText").modal({ backdrop: "static", keyboard: false });
    },

    selectedSmsTempIcon(sms) {
      if (sms.smsTemplateId == 0) return "fas fa-envelope mr-3";
      else return "far fa-file-alt mr-3";
    },

    smsTempsListClick(sms) {
      this.selectedSmsId = sms.smsTemplateId;
      if (sms.smsTemplateId > 0)
        this.aSingleSms = JSON.parse(JSON.stringify(sms));
      else this.aSingleSms = { name: "", smsTemplateId: 0, smsText: "" };
    },
    selectedSmsTempClass(sms) {
      if (sms.smsTemplateId === 0)
        return "list-group-item list-group-item-action btn-success";
      else {
        if (this.selectedSmsId == sms.smsTemplateId)
          return "list-group-item list-group-item-action active show";
        else return "list-group-item list-group-item-action show";
      }
    },
    SendSms() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Patient/SendSMS";
      //this.aSingleInsurance.fndx = this.aSinglePatient.pndx;
      const dc = this.dummyComm;
      const Sms = {
        PhoneNumber: this.aSinglePatient.phone,
        MessageBody: this.aSingleSms.smsText,
        PatientID: this.aSinglePatient.patientId,
        UserId: 0,
        VisitId: 0,
        LocalTime: new Date(),
      };
      const myData = {
        dc: dc,
        Sms: Sms,
      };
      this.axiosGetData(url, myData, 27);
    },
    smsContactClick(User) {
      this.aSingleText.userId = User.userId;
      if (User.userId > 0) this.aSingleText = JSON.parse(JSON.stringify(User));
      else
        this.aSingleText = {
          userId: 0,
        };
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetUserSmsHist";
      this.intDummyComm();
      this.dummyComm.extras = this.aSinglePatient.visitId;
      this.dummyComm.visitId =  this.aSingleText.userId;
      this.axiosGetData(url, this.dummyComm, 24);
    },
    clickSmsLis(sms) {
      if (sms.userId === 0)
        return "list-group-item list-group-item-action btn-success";
      else {
        if (this.aSingleText.userId == sms.userId)
          return "list-group-item list-group-item-action active show";
        else return "list-group-item list-group-item-action show";
      }
    },
    chatSmsSent() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.extras2 = this.aSingleText.userId;
      const url = this.SERVER + "/VNSPRAAPI/Patient/SendSMS";
      //this.aSingleInsurance.fndx = this.aSinglePatient.pndx;
      const dc = this.dummyComm;
      const Sms = {
        PhoneNumber: this.aSinglePatient.phone,
        MessageBody: this.chatSms,
        PatientID: this.aSinglePatient.patientId,
        UserId: 0,
        VisitId: this.aSinglePatient.visitId,
        LocalTime: new Date(),
      };
      const myData = {
        dc: dc,
        Sms: Sms,
      };
      this.axiosGetData(url, myData, 27);
    },
     PhOrderBy(column){
    //debugger
      // if(this.firstTime==true)
      // {
      //   this.firstTime = false;
      //   return;
      // }
      this.orderByCol = column;
      if(column==1)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.dosStr < b.dosStr) ? 1 : ((b.dosStr < a.dosStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.dosStr > b.dosStr) ? 1 : ((b.dosStr > a.dosStr) ? -1 : 0))
        }
        
      }
      if(column==2)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.amount < b.amount) ? 1 : ((b.amount < a.amount) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.amount > b.amount) ? 1 : ((b.amount > a.amount) ? -1 : 0))
        }
      }
      if(column==3)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.paymentMethodStr < b.paymentMethodStr) ? 1 : ((b.paymentMethodStr < a.paymentMethodStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.paymentMethodStr > b.paymentMethodStr) ? 1 : ((b.paymentMethodStr > a.paymentMethodStr) ? -1 : 0))
        }
      }
      if(column==4)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.comment < b.comment) ? 1 : ((b.comment < a.comment) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.comment > b.comment) ? 1 : ((b.comment > a.comment) ? -1 : 0))
        }
      }
      if(column==5)
      {
      if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.statusStr < b.statusStr) ? 1 : ((b.statusStr < a.statusStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.statusStr > b.statusStr) ? 1 : ((b.statusStr > a.statusStr) ? -1 : 0))
        }
      }
      if(column==6)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.paymentDateStr < b.paymentDateStr) ? 1 : ((b.paymentDateStr < a.paymentDateStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.paymentDateStr > b.paymentDateStr) ? 1 : ((b.paymentDateStr > a.paymentDateStr) ? -1 : 0))
        }
      }
      if(column==7)
      {
        if(this.asc_desc == "asc")
        {// changes in payment section
          this.asc_desc ="desc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.collectedByName < b.collectedByName) ? 1 : ((b.collectedByName < a.collectedByName) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.paymentHistory =this.paymentHistory.sort((a,b) => (a.collectedByName > b.collectedByName) ? 1 : ((b.collectedByName > a.collectedByName) ? -1 : 0))
        }
      }
      this.ResetLogoutTime();
    },
       PhpageChange(obj) {
      if (obj == "Next") {
        if (this.PhpageNumber < this.PhtotalPages) {
          this.PhpageNumber += 1;
        }
      } else if (obj == "Previous" && this.PhpageNumber != 1) {
        this.PhpageNumber -= 1;
      } else {
        this.PhpageNumber = obj;
      }

        if((this.showPagesMax1/2) < (this.PhpageNumber))
        {
          this.showPagesMin1 = this.PhpageNumber-4;
          this.showPagesMax1 = this.PhpageNumber+4;
        }
        else if((this.showPagesMin1/2)<(this.PhpageNumber))
        {
          this.showPagesMin1 = this.PhpageNumber-4;
          this.showPagesMax1 = this.PhpageNumber+4 ;
          if(this.showPagesMax1<5)
          {
            this.showPagesMax1 = 5;
          }
        }
        else{
          this.showPagesMin1 = 1;
          this.showPagesMax1 = 5 ;
        }

      this.fetchPayHistory();
    },
    fetchPayHistory() {
      this.intDummyComm();
      if (!this.aSinglePatient) {
        return;
      }
      this.dummyComm.pageNumber = 1;
      this.dummyComm.pageSize = this.pageSize;
      //this.dummyComm.extras = this.initDate_2;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.loader = this.$loading.show({
        color: "#03a9f3",
      });
      const url = this.SERVER + "/VNSPRAAPI/Patient/GetPaymentHistoryTable";
      this.getaxiosPayHistory(url, this.dummyComm);
    },
    async getaxiosPayHistory(url, myData) {
      await axios({
        method: "post",
        url: url,
        data: myData, headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          const response = res.data;
          if (response.dc.auditFlag == 1) {
            this.paymentHistory = res.data.paymentHistory;
            this.PhpageNumber = response.pageNumberP;
            this.PhtotalPages =response.totalPagesP;
            this.PhtotalRows = response.totalRowsP;
          } else {
            this.showErrorToast("unable to fetch data");
            console.log("unable to fetch data");
          }
        })
        .catch(function (error) {
          if (error.response) {
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {
          this.loader.hide();
          this.ResetLogoutTime();
          this.calcTimerRoutine();
        });
    },
       VhOrderBy(column){
      if(this.firstTime==true)
      {
        this.firstTime = false;
        return;
      }
      this.orderByCol = column;
      if(column==1)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.visitTypeName < b.visitTypeName) ? 1 : ((b.visitTypeName < a.visitTypeName) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.visitTypeName > b.visitTypeName) ? 1 : ((b.visitTypeName > a.visitTypeName) ? -1 : 0))
        }
        
      }
      if(column==2)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.reason < b.reason) ? 1 : ((b.reason < a.reason) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.reason > b.reason) ? 1 : ((b.reason > a.reason) ? -1 : 0))
        }
      }
      if(column==3)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.dosLocalDateStr < b.dosLocalDateStr) ? 1 : ((b.dosLocalDateStr < a.dosLocalDateStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.dosLocalDateStr > b.dosLocalDateStr) ? 1 : ((b.dosLocalDateStr > a.dosLocalDateStr) ? -1 : 0))
        }
      }
      if(column==4)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.dosLocalTimeStr < b.dosLocalTimeStr) ? 1 : ((b.dosLocalTimeStr < a.dosLocalTimeStr) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.visitHistory =this.practices.sort((a,b) => (a.dosLocalTimeStr > b.dosLocalTimeStr) ? 1 : ((b.dosLocalTimeStr > a.dosLocalTimeStr) ? -1 : 0))
        }
      }
      if(column==5)
      {
      if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.stageName < b.stageName) ? 1 : ((b.stageName < a.stageName) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.stageName > b.stageName) ? 1 : ((b.stageName > a.stageName) ? -1 : 0))
        }
      }
      if(column==6)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.stepName < b.stepName) ? 1 : ((b.stepName < a.stepName) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.stepName > b.stepName) ? 1 : ((b.stepName > a.stepName) ? -1 : 0))
        }
      }
      if(column==7)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.physicianName < b.physicianName) ? 1 : ((b.physicianName < a.physicianName) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.physicianName > b.physicianName) ? 1 : ((b.physicianName > a.physicianName) ? -1 : 0))
        }
      }
      if(column==8)
      {
        if(this.asc_desc == "asc")
        {
          this.asc_desc ="desc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.commentText < b.commentText) ? 1 : ((b.commentText < a.commentText) ? -1 : 0));
        }
        else
        {
          this.asc_desc ="asc";
          this.visitHistory =this.visitHistory.sort((a,b) => (a.commentText > b.commentText) ? 1 : ((b.commentText > a.commentText) ? -1 : 0))
        }
      }
      this.ResetLogoutTime();
    
    },
    VhpageChange(obj) {
    if (obj == "Next") {
      if (this.VhpageNumber < this.VhtotalPages) {
        this.VhpageNumber += 1;
      }
    } else if (obj == "Previous" && this.VhpageNumber != 1) {
      this.VhpageNumber -= 1;
    } else {
      this.VhpageNumber = obj;
    }

      if((this.showPagesMax1/2) < (this.VhpageNumber))
      {
        this.showPagesMin1 = this.VhpageNumber-4;
        this.showPagesMax1 = this.VhpageNumber+4;
      }
      else if((this.showPagesMin1/2)<(this.VhpageNumber))
      {
        this.showPagesMin1 = this.VhpageNumber-4;
        this.showPagesMax1 = this.VhpageNumber+4 ;
        if(this.showPagesMax1<5)
        {
          this.showPagesMax1 = 5;
        }
      }
      else{
        this.showPagesMin1 = 1;
        this.showPagesMax1 = 5 ;
      }

    this.fetchVisitistory();
    },
    fetchVisitistory() {
      this.intDummyComm();
     //debugger
      if (!this.aSinglePatient) {
        return;
      }
      this.dummyComm.pageNumber = 1;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.extras = this.initDate_2;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.loader = this.$loading.show({
        color: "#03a9f3",
      });
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetVisitHistory";
      this.getaxiosHistory(url, this.dummyComm);
    },
    async getaxiosHistory(url, myData) {
     //debugger
      await axios({
        method: "post",
        url: url,
        data: myData,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
         //debugger
          console.log(res);
          const response = res.data;
          if (response.dc.auditFlag == 1) {
            this.visitHistory = res.data.patientVisitHistories;
            this.VhpageNumber = response.vhPageNumber;
            
            this.VhtotalPages =response.vhTotalPages;
            this.VhtotalRows = response.vhTotalRows
          } else {
            this.showErrorToast("unable to fetch data");
            console.log("unable to fetch data");
          }
        })
        .catch(function (error) {
          if (error.response) {
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {
          this.loader.hide();
          this.ResetLogoutTime();
          this.calcTimerRoutine();
        });
    },
  }, // methods
  watch: {
    //    allFilterPatients: function() {
    //     this.$nextTick(() => {
    //     $("#home_2").DataTable().destroy();
    //     $("#home_2").DataTable({
    //         buttons: [
    //                 'copy', 'csv', 'excel', 'pdf', 'print'
    //         ]
    //       });
    //       $('.buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel').addClass('btn btn-primary mr-1');
    //     $(".home_2").DataTable().draw();
    //   }); // this.$nextTick
    // },
    //For search
        initDate_2: function () {
      this.fetchVisitistory();
    },
    requestPaymentsList: function() {
      try {
        for (let i = 0; i < this.requestPaymentsList.length; i++) {
          let dd = new Date(this.requestPaymentsList[i].dos);
          this.requestPaymentsList[i].dosDate = dd.toLocaleDateString();
          dd = new Date(this.requestPaymentsList[i].billDate);
          this.requestPaymentsList[i].billDateDate = dd.toLocaleDateString();
          this.requestPaymentsList[i].inputStatus = this.requestPaymentsList[
            i
          ].status;
        }
      } catch {
        /**/
      } finally {
        this.allFilterPatients_1 = this.requestPaymentsList;
        this.searchMainList_1();
        //   this.$nextTick(() => {
        //   $("#paym").DataTable().destroy();
        //   $("#paym").DataTable({
        //       buttons: [
        //               'copy', 'csv', 'excel', 'pdf', 'print'
        //       ]
        //     });
        //     $('.buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel').addClass('btn btn-primary mr-1');
        //   $(".paym").DataTable().draw();
        // });
      }
    },
    //For search
    visitHistory: function() {
      
      
    },
    userTexts: function() {
      this.filterTextSearch = this.userTexts;
      this.filterSearchList_1();
    },

    //For search
    paymentHistory: function() {
      this.allFilterPayHist = this.paymentHistory;
      this.searchMainList_3();
      this.$nextTick(() => {
        $("#payhm")
          .DataTable()
          .destroy();
        $("#payhm").DataTable({
          buttons: ["copy", "csv", "excel", "pdf", "print"],
        });
        $(
          ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
        ).addClass("btn btn-primary mr-1");
        $(".payhm")
          .DataTable()
          .draw();
      });
    },
    allRawPatients: function() {
      try {
        for (let i = 0; i < this.allRawPatients.length; i++) {
          const dd = new Date(this.allRawPatients[i].dos);
          this.allRawPatients[i].dosdate = dd.toLocaleDateString();
          this.allRawPatients[i].dostime = dd.toLocaleTimeString();
          const ddd = new Date(this.allRawPatients[i].dob);
          this.allRawPatients[i].dob = ddd.toLocaleDateString();
        }
        //this.stageClick(0);
        //this.searchMainList();
      } catch {
        /**/
      } finally {
        /**/
        this.allFilterPatients = this.allRawPatients;
        this.searchMainList();
        // this.$nextTick(() => {
        //   $("#home_2").DataTable().destroy();
        //   $("#home_2").DataTable({
        //       buttons: [
        //               'copy', 'csv', 'excel', 'pdf', 'print'
        //       ]
        //     });
        //     $('.buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel').addClass('btn btn-primary mr-1');
        //   $(".home_2").DataTable().draw();
        // });
      }
    },
    "mainSearch.searchExternalId": function() {
      this.searchMainList();
    },
    "mainSearch.searchFirstName": function() {
      this.searchMainList();
    },
    "mainSearch.searchLastName": function() {
      this.searchMainList();
    },
    "mainSearch.searchPhone": function() {
      this.searchMainList();
    },
    "mainSearch.searchDate": function() {
      this.searchMainList();
    },
    startDate: function() {
      this.searchMainList_1();
    },
    endDate: function() {
      this.searchMainList_1();
    },
    startDate_1: function() {
      this.searchMainList_2();
    },
    endDate_1: function() {
      this.searchMainList_2();
    },
    startDate_2: function() {
      this.searchMainList_3();
    },
    endDate_2: function() {
      this.searchMainList_3();
    },
    filterFirstName: function() {
      this.filterSearchList();
    },
    filterLastName: function() {
      this.filterSearchList();
    },
    filterPhone: function() {
      this.filterSearchList();
    },
    filterDate: function() {
      // let dd = new Date(this.filterDate);
      // let ds = dd.toLocaleDateString();
      //   alert(dd);
      this.filterSearchList();
    },
    TextSearch: function() {
      this.filterSearchList_1();
    },
  }, // watch:
  mounted() {
    if(this.$store.getters.getAuthToken==="")
    {
        this.$store.commit('setAuthToken',localStorage.BeToken);
    }
    clearTimeout(this.loadObj);
    this.emailHisUser = localStorage.getItem("UserName");
    this.handleRole();
    this.loadInit();
  }, // mounted
  unmounted() {
    clearTimeout(this.TimerObject);
  },
};
</script>

<style scoped>
.float-textarea,
.float-class:hover {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 1px solid rgb(235, 235, 235);
  /* box-shadow: none; */
  width: 98%;
}
.float-textarea:focus {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 2px solid rgb(240, 141, 11);
  /* box-shadow: none; */
  width: 98%;
}
.float-class,
.float-class:hover {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  /* border-bottom: 2px solid rgb(240, 141, 11); */
  border-bottom: 1px solid rgb(235, 235, 235);
  box-shadow: none;
}
.float-class:focus {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 2px solid rgb(240, 141, 11);
  box-shadow: none;
}
#font1 {
  font-weight: bold;
  font-size: 15px;
  margin-left: -7px;
}
.label_select {
  margin-top: -23px;
  margin-left: 0px;
}
.activeColor {
  background-color: #fb9678;
  color: white;
}
.colorActive {
  color: #f95c2e;
}
.disabledColor {
  color: gray;
  background: lightgrey;
}
.asc-desc-btn {
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  color: honeydew;
  float: right;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input:checked + .slider {
  background-color: #00c292;
}
input:focus + .slider {
  box-shadow: 0 0 1px #00c292;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  height: 34px;
  width: 56px;
  border-radius: 24px;
}
.slider.round:before {
  border-radius: 50%;
}
.label-color {
  color: black;
}
#chat {
  margin-top: -67px;
  position: absolute;
  margin-left: 500px;
}
</style>
